// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: intent_compiler.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import { AlgoState } from './algo'
import { PortfolioData } from './common/account'
import {
  AssetRef,
  Denomination,
  denominationFromJSON,
  denominationToJSON,
  Order,
  OrderSide,
  orderSideFromJSON,
  orderSideToJSON,
  TimeInForce,
  timeInForceFromJSON,
  timeInForceToJSON,
} from './common/trading'
import {
  Instrument,
  OptionType,
  optionTypeFromJSON,
  optionTypeToJSON,
  PriceReference,
  priceReferenceFromJSON,
  priceReferenceToJSON,
} from './common/types'
import { TriggerCondition } from './execution'
import { AutoApprove, AutoRetry } from './rfq'
import { Trigger } from './triggers'

export const protobufPackage = 'intent_compiler'

export enum QuantityDeltaDirection {
  QUANTITY_DELTA_DIRECTION_UNSPECIFIED = 0,
  QUANTITY_DELTA_DIRECTION_ADD = 1,
  QUANTITY_DELTA_DIRECTION_SUBTRACT = 2,
  UNRECOGNIZED = -1,
}

export function quantityDeltaDirectionFromJSON(object: any): QuantityDeltaDirection {
  switch (object) {
    case 0:
    case 'QUANTITY_DELTA_DIRECTION_UNSPECIFIED':
      return QuantityDeltaDirection.QUANTITY_DELTA_DIRECTION_UNSPECIFIED
    case 1:
    case 'QUANTITY_DELTA_DIRECTION_ADD':
      return QuantityDeltaDirection.QUANTITY_DELTA_DIRECTION_ADD
    case 2:
    case 'QUANTITY_DELTA_DIRECTION_SUBTRACT':
      return QuantityDeltaDirection.QUANTITY_DELTA_DIRECTION_SUBTRACT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return QuantityDeltaDirection.UNRECOGNIZED
  }
}

export function quantityDeltaDirectionToJSON(object: QuantityDeltaDirection): string {
  switch (object) {
    case QuantityDeltaDirection.QUANTITY_DELTA_DIRECTION_UNSPECIFIED:
      return 'QUANTITY_DELTA_DIRECTION_UNSPECIFIED'
    case QuantityDeltaDirection.QUANTITY_DELTA_DIRECTION_ADD:
      return 'QUANTITY_DELTA_DIRECTION_ADD'
    case QuantityDeltaDirection.QUANTITY_DELTA_DIRECTION_SUBTRACT:
      return 'QUANTITY_DELTA_DIRECTION_SUBTRACT'
    case QuantityDeltaDirection.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ExecutionStyleKind {
  EXECUTION_STYLE_KIND_UNSPECIFIED = 0,
  EXECUTION_STYLE_KIND_MARKET = 1,
  EXECUTION_STYLE_KIND_LIMIT = 2,
  EXECUTION_STYLE_KIND_TWAP = 3,
  EXECUTION_STYLE_KIND_LIMIT_CHASE = 4,
  EXECUTION_STYLE_KIND_SCALE = 5,
  UNRECOGNIZED = -1,
}

export function executionStyleKindFromJSON(object: any): ExecutionStyleKind {
  switch (object) {
    case 0:
    case 'EXECUTION_STYLE_KIND_UNSPECIFIED':
      return ExecutionStyleKind.EXECUTION_STYLE_KIND_UNSPECIFIED
    case 1:
    case 'EXECUTION_STYLE_KIND_MARKET':
      return ExecutionStyleKind.EXECUTION_STYLE_KIND_MARKET
    case 2:
    case 'EXECUTION_STYLE_KIND_LIMIT':
      return ExecutionStyleKind.EXECUTION_STYLE_KIND_LIMIT
    case 3:
    case 'EXECUTION_STYLE_KIND_TWAP':
      return ExecutionStyleKind.EXECUTION_STYLE_KIND_TWAP
    case 4:
    case 'EXECUTION_STYLE_KIND_LIMIT_CHASE':
      return ExecutionStyleKind.EXECUTION_STYLE_KIND_LIMIT_CHASE
    case 5:
    case 'EXECUTION_STYLE_KIND_SCALE':
      return ExecutionStyleKind.EXECUTION_STYLE_KIND_SCALE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ExecutionStyleKind.UNRECOGNIZED
  }
}

export function executionStyleKindToJSON(object: ExecutionStyleKind): string {
  switch (object) {
    case ExecutionStyleKind.EXECUTION_STYLE_KIND_UNSPECIFIED:
      return 'EXECUTION_STYLE_KIND_UNSPECIFIED'
    case ExecutionStyleKind.EXECUTION_STYLE_KIND_MARKET:
      return 'EXECUTION_STYLE_KIND_MARKET'
    case ExecutionStyleKind.EXECUTION_STYLE_KIND_LIMIT:
      return 'EXECUTION_STYLE_KIND_LIMIT'
    case ExecutionStyleKind.EXECUTION_STYLE_KIND_TWAP:
      return 'EXECUTION_STYLE_KIND_TWAP'
    case ExecutionStyleKind.EXECUTION_STYLE_KIND_LIMIT_CHASE:
      return 'EXECUTION_STYLE_KIND_LIMIT_CHASE'
    case ExecutionStyleKind.EXECUTION_STYLE_KIND_SCALE:
      return 'EXECUTION_STYLE_KIND_SCALE'
    case ExecutionStyleKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum AmountKind {
  AMOUNT_KIND_UNSPECIFIED = 0,
  /** AMOUNT_KIND_EXACT_BASE - `value` is a base-asset quantity, e.g. BTC/ETH units. */
  AMOUNT_KIND_EXACT_BASE = 1,
  /** AMOUNT_KIND_EXACT_QUOTE - `value` is the quote/notional amount actually spent/received. */
  AMOUNT_KIND_EXACT_QUOTE = 2,
  /** AMOUNT_KIND_PERCENT_POSITION - `value` is percentage points of an existing position. */
  AMOUNT_KIND_PERCENT_POSITION = 3,
  /** AMOUNT_KIND_PERCENT_PORTFOLIO - `value` is percentage points of portfolio / source-side value. */
  AMOUNT_KIND_PERCENT_PORTFOLIO = 4,
  /**
   * AMOUNT_KIND_ALL_AVAILABLE - Use all available of the enclosing action's inferred asset/currency.
   * `value` must be absent.
   */
  AMOUNT_KIND_ALL_AVAILABLE = 5,
  /**
   * AMOUNT_KIND_MATCH_POSITION - Match a singular existing position selected by `match_position_key`.
   * Requires `match_basis`; `value` and `currency` must be absent.
   */
  AMOUNT_KIND_MATCH_POSITION = 6,
  /**
   * AMOUNT_KIND_MATCH_LEG - Sized at compile time to be value-equivalent, at current mark prices, to
   * another leg in the same create_rfq (see Amount.match_leg_index):
   * qty = floor((referenced_qty * its_mark / this_mark) / min_trade) * min_trade.
   * The compiled plan carries the resulting exact-sized leg inside the same
   * atomic RFQ package; the net premium difference settles in cash. `value`
   * and `currency` must be absent. Only valid on create_rfq legs.
   */
  AMOUNT_KIND_MATCH_LEG = 7,
  UNRECOGNIZED = -1,
}

export function amountKindFromJSON(object: any): AmountKind {
  switch (object) {
    case 0:
    case 'AMOUNT_KIND_UNSPECIFIED':
      return AmountKind.AMOUNT_KIND_UNSPECIFIED
    case 1:
    case 'AMOUNT_KIND_EXACT_BASE':
      return AmountKind.AMOUNT_KIND_EXACT_BASE
    case 2:
    case 'AMOUNT_KIND_EXACT_QUOTE':
      return AmountKind.AMOUNT_KIND_EXACT_QUOTE
    case 3:
    case 'AMOUNT_KIND_PERCENT_POSITION':
      return AmountKind.AMOUNT_KIND_PERCENT_POSITION
    case 4:
    case 'AMOUNT_KIND_PERCENT_PORTFOLIO':
      return AmountKind.AMOUNT_KIND_PERCENT_PORTFOLIO
    case 5:
    case 'AMOUNT_KIND_ALL_AVAILABLE':
      return AmountKind.AMOUNT_KIND_ALL_AVAILABLE
    case 6:
    case 'AMOUNT_KIND_MATCH_POSITION':
      return AmountKind.AMOUNT_KIND_MATCH_POSITION
    case 7:
    case 'AMOUNT_KIND_MATCH_LEG':
      return AmountKind.AMOUNT_KIND_MATCH_LEG
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AmountKind.UNRECOGNIZED
  }
}

export function amountKindToJSON(object: AmountKind): string {
  switch (object) {
    case AmountKind.AMOUNT_KIND_UNSPECIFIED:
      return 'AMOUNT_KIND_UNSPECIFIED'
    case AmountKind.AMOUNT_KIND_EXACT_BASE:
      return 'AMOUNT_KIND_EXACT_BASE'
    case AmountKind.AMOUNT_KIND_EXACT_QUOTE:
      return 'AMOUNT_KIND_EXACT_QUOTE'
    case AmountKind.AMOUNT_KIND_PERCENT_POSITION:
      return 'AMOUNT_KIND_PERCENT_POSITION'
    case AmountKind.AMOUNT_KIND_PERCENT_PORTFOLIO:
      return 'AMOUNT_KIND_PERCENT_PORTFOLIO'
    case AmountKind.AMOUNT_KIND_ALL_AVAILABLE:
      return 'AMOUNT_KIND_ALL_AVAILABLE'
    case AmountKind.AMOUNT_KIND_MATCH_POSITION:
      return 'AMOUNT_KIND_MATCH_POSITION'
    case AmountKind.AMOUNT_KIND_MATCH_LEG:
      return 'AMOUNT_KIND_MATCH_LEG'
    case AmountKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum MatchPositionBasis {
  MATCH_POSITION_BASIS_UNSPECIFIED = 0,
  MATCH_POSITION_BASIS_NOTIONAL_USD = 1,
  MATCH_POSITION_BASIS_BASE_QUANTITY = 2,
  MATCH_POSITION_BASIS_DELTA_USD = 3,
  MATCH_POSITION_BASIS_UNDERLYING_DELTA = 4,
  UNRECOGNIZED = -1,
}

export function matchPositionBasisFromJSON(object: any): MatchPositionBasis {
  switch (object) {
    case 0:
    case 'MATCH_POSITION_BASIS_UNSPECIFIED':
      return MatchPositionBasis.MATCH_POSITION_BASIS_UNSPECIFIED
    case 1:
    case 'MATCH_POSITION_BASIS_NOTIONAL_USD':
      return MatchPositionBasis.MATCH_POSITION_BASIS_NOTIONAL_USD
    case 2:
    case 'MATCH_POSITION_BASIS_BASE_QUANTITY':
      return MatchPositionBasis.MATCH_POSITION_BASIS_BASE_QUANTITY
    case 3:
    case 'MATCH_POSITION_BASIS_DELTA_USD':
      return MatchPositionBasis.MATCH_POSITION_BASIS_DELTA_USD
    case 4:
    case 'MATCH_POSITION_BASIS_UNDERLYING_DELTA':
      return MatchPositionBasis.MATCH_POSITION_BASIS_UNDERLYING_DELTA
    case -1:
    case 'UNRECOGNIZED':
    default:
      return MatchPositionBasis.UNRECOGNIZED
  }
}

export function matchPositionBasisToJSON(object: MatchPositionBasis): string {
  switch (object) {
    case MatchPositionBasis.MATCH_POSITION_BASIS_UNSPECIFIED:
      return 'MATCH_POSITION_BASIS_UNSPECIFIED'
    case MatchPositionBasis.MATCH_POSITION_BASIS_NOTIONAL_USD:
      return 'MATCH_POSITION_BASIS_NOTIONAL_USD'
    case MatchPositionBasis.MATCH_POSITION_BASIS_BASE_QUANTITY:
      return 'MATCH_POSITION_BASIS_BASE_QUANTITY'
    case MatchPositionBasis.MATCH_POSITION_BASIS_DELTA_USD:
      return 'MATCH_POSITION_BASIS_DELTA_USD'
    case MatchPositionBasis.MATCH_POSITION_BASIS_UNDERLYING_DELTA:
      return 'MATCH_POSITION_BASIS_UNDERLYING_DELTA'
    case MatchPositionBasis.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TenorUnit {
  TENOR_UNIT_UNSPECIFIED = 0,
  TENOR_UNIT_DAYS = 1,
  TENOR_UNIT_WEEKS = 2,
  TENOR_UNIT_MONTHS = 3,
  TENOR_UNIT_YEARS = 4,
  UNRECOGNIZED = -1,
}

export function tenorUnitFromJSON(object: any): TenorUnit {
  switch (object) {
    case 0:
    case 'TENOR_UNIT_UNSPECIFIED':
      return TenorUnit.TENOR_UNIT_UNSPECIFIED
    case 1:
    case 'TENOR_UNIT_DAYS':
      return TenorUnit.TENOR_UNIT_DAYS
    case 2:
    case 'TENOR_UNIT_WEEKS':
      return TenorUnit.TENOR_UNIT_WEEKS
    case 3:
    case 'TENOR_UNIT_MONTHS':
      return TenorUnit.TENOR_UNIT_MONTHS
    case 4:
    case 'TENOR_UNIT_YEARS':
      return TenorUnit.TENOR_UNIT_YEARS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TenorUnit.UNRECOGNIZED
  }
}

export function tenorUnitToJSON(object: TenorUnit): string {
  switch (object) {
    case TenorUnit.TENOR_UNIT_UNSPECIFIED:
      return 'TENOR_UNIT_UNSPECIFIED'
    case TenorUnit.TENOR_UNIT_DAYS:
      return 'TENOR_UNIT_DAYS'
    case TenorUnit.TENOR_UNIT_WEEKS:
      return 'TENOR_UNIT_WEEKS'
    case TenorUnit.TENOR_UNIT_MONTHS:
      return 'TENOR_UNIT_MONTHS'
    case TenorUnit.TENOR_UNIT_YEARS:
      return 'TENOR_UNIT_YEARS'
    case TenorUnit.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum DeltaDenomination {
  DELTA_DENOMINATION_UNSPECIFIED = 0,
  DELTA_DENOMINATION_UNDERLYING_UNITS = 1,
  DELTA_DENOMINATION_USD = 2,
  UNRECOGNIZED = -1,
}

export function deltaDenominationFromJSON(object: any): DeltaDenomination {
  switch (object) {
    case 0:
    case 'DELTA_DENOMINATION_UNSPECIFIED':
      return DeltaDenomination.DELTA_DENOMINATION_UNSPECIFIED
    case 1:
    case 'DELTA_DENOMINATION_UNDERLYING_UNITS':
      return DeltaDenomination.DELTA_DENOMINATION_UNDERLYING_UNITS
    case 2:
    case 'DELTA_DENOMINATION_USD':
      return DeltaDenomination.DELTA_DENOMINATION_USD
    case -1:
    case 'UNRECOGNIZED':
    default:
      return DeltaDenomination.UNRECOGNIZED
  }
}

export function deltaDenominationToJSON(object: DeltaDenomination): string {
  switch (object) {
    case DeltaDenomination.DELTA_DENOMINATION_UNSPECIFIED:
      return 'DELTA_DENOMINATION_UNSPECIFIED'
    case DeltaDenomination.DELTA_DENOMINATION_UNDERLYING_UNITS:
      return 'DELTA_DENOMINATION_UNDERLYING_UNITS'
    case DeltaDenomination.DELTA_DENOMINATION_USD:
      return 'DELTA_DENOMINATION_USD'
    case DeltaDenomination.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum PriceOffsetUnit {
  PRICE_OFFSET_UNIT_UNSPECIFIED = 0,
  PRICE_OFFSET_UNIT_QUOTE_VALUE = 1,
  PRICE_OFFSET_UNIT_BPS = 2,
  PRICE_OFFSET_UNIT_PERCENT = 3,
  PRICE_OFFSET_UNIT_TICKS = 4,
  UNRECOGNIZED = -1,
}

export function priceOffsetUnitFromJSON(object: any): PriceOffsetUnit {
  switch (object) {
    case 0:
    case 'PRICE_OFFSET_UNIT_UNSPECIFIED':
      return PriceOffsetUnit.PRICE_OFFSET_UNIT_UNSPECIFIED
    case 1:
    case 'PRICE_OFFSET_UNIT_QUOTE_VALUE':
      return PriceOffsetUnit.PRICE_OFFSET_UNIT_QUOTE_VALUE
    case 2:
    case 'PRICE_OFFSET_UNIT_BPS':
      return PriceOffsetUnit.PRICE_OFFSET_UNIT_BPS
    case 3:
    case 'PRICE_OFFSET_UNIT_PERCENT':
      return PriceOffsetUnit.PRICE_OFFSET_UNIT_PERCENT
    case 4:
    case 'PRICE_OFFSET_UNIT_TICKS':
      return PriceOffsetUnit.PRICE_OFFSET_UNIT_TICKS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PriceOffsetUnit.UNRECOGNIZED
  }
}

export function priceOffsetUnitToJSON(object: PriceOffsetUnit): string {
  switch (object) {
    case PriceOffsetUnit.PRICE_OFFSET_UNIT_UNSPECIFIED:
      return 'PRICE_OFFSET_UNIT_UNSPECIFIED'
    case PriceOffsetUnit.PRICE_OFFSET_UNIT_QUOTE_VALUE:
      return 'PRICE_OFFSET_UNIT_QUOTE_VALUE'
    case PriceOffsetUnit.PRICE_OFFSET_UNIT_BPS:
      return 'PRICE_OFFSET_UNIT_BPS'
    case PriceOffsetUnit.PRICE_OFFSET_UNIT_PERCENT:
      return 'PRICE_OFFSET_UNIT_PERCENT'
    case PriceOffsetUnit.PRICE_OFFSET_UNIT_TICKS:
      return 'PRICE_OFFSET_UNIT_TICKS'
    case PriceOffsetUnit.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Decimal string convention for this package:
 * - Plain decimal fields are base/quote/price/delta units in the field's
 *   documented denomination; they are not floating-point JSON numbers.
 * - Fields whose name ends in `_percent` or whose unit enum is `PERCENT` use
 *   percentage points, not fractions: "50" means 50%; "0.5" means 0.5%.
 * - Signed fields say so explicitly. Delta fields are signed only when the
 *   surrounding comment says they are signed.
 */
export interface TradeIntent {
  accountId: string
  actions: Action[]
  algoSubscriptions: AlgoSubscription[]
  management: Management[]
}

export interface Action {
  /**
   * Generic deferred execution trigger. This is not for venue-native stop-loss
   * or take-profit orders; use Acquire.trigger_condition or
   * Reduce.trigger_condition for those. When set, the compiler builds the action
   * into an isolated fire payload and emits a DraftExecutionPlan triggered_item;
   * the trigger condition is passed through opaquely for the alerts service to
   * resolve at registration time.
   */
  trigger?: Trigger | undefined
  /**
   * Allows the compiler to rewrite execution style for safety/capability
   * reasons, e.g. Market -> TWAP for large orders. When absent, the compiler
   * uses IntentCompilerConfig.default_allow_execution_style_upgrade.
   */
  allowExecutionStyleUpgrade?: boolean | undefined
  acquire?: Acquire | undefined
  reduce?: Reduce | undefined
  roll?: Roll | undefined
  createRfq?: CreateRfq | undefined
  singleHedge?: SingleHedge | undefined
}

export interface AlgoSubscription {
  /**
   * Generic deferred execution trigger; same pass-through semantics as
   * Action.trigger. When set, the hedge subscription is compiled into a
   * triggered_item fire payload instead of the immediate batch.
   */
  trigger?: Trigger | undefined
  /**
   * Same semantics as Action.allow_execution_style_upgrade. When absent, the
   * compiler uses IntentCompilerConfig.default_allow_execution_style_upgrade.
   */
  allowExecutionStyleUpgrade?: boolean | undefined
  hedge?: HedgeSubscription | undefined
}

export interface Management {
  /**
   * Generic deferred execution trigger; same pass-through semantics as
   * Action.trigger. cancel_all_orders is refused when triggered (a fire payload
   * cannot carry a cancel-all scope); the other operations are supported.
   */
  trigger?: Trigger | undefined
  updateOrder?: UpdateOrder | undefined
  cancelOrder?: CancelOrder | undefined
  cancelAlgo?: CancelAlgo | undefined
  cancelAllOrders?: CancelAllOrders | undefined
  cancelRfq?: CancelRfq | undefined
}

export interface CreateRfq {
  legs: RfqIntentLeg[]
  hedge?: RfqIntentHedge | undefined
  /** empty (the AI default) = all makers */
  makerIds: string[]
  /** default false */
  disclosed?: boolean | undefined
  autoApprove?: AutoApprove | undefined
  autoRetry?: AutoRetry | undefined
}

export interface RfqIntentLeg {
  /** symbol or OptionSelector — compiler resolves */
  instrument: InstrumentRef | undefined
  amount: Amount | undefined
  side: OrderSide
}

export interface RfqIntentHedge {
  instrument: InstrumentRef | undefined
  amount: Amount | undefined
  side: OrderSide
  price: PriceSpec | undefined
}

export interface CancelRfq {
  rfqId: string
}

export interface Acquire {
  instrument: InstrumentRef | undefined
  amount: Amount | undefined
  executionStyle: ExecutionStyle | undefined
  /**
   * Open/increase direction. Defaults to BUY. For derivatives, SELL means
   * open/increase short exposure (e.g. "short BTC perp"). For spot, SELL is
   * only valid when the venue/account supports sell-to-open or margin shorting;
   * otherwise the compiler refuses it.
   */
  side?: OrderSide | undefined
  /**
   * Venue-native conditional order trigger, emitted directly as
   * execution.NewOrderParams.trigger_condition. Use this for stop-entry /
   * take-entry style orders, not for watching another action's lifecycle.
   */
  triggerCondition?: TriggerCondition | undefined
  /**
   * Currency to pay with for a spot buy (e.g. "USDT", "KRW"). Setting this
   * routes the acquire as a bare-asset spot acquisition: instrument.symbol
   * names the base asset ("ETH") and the compiler resolves the venue's
   * {asset}/{quote_currency} spot market (refusing, with the venue default
   * suggested, when no such pair exists). Absent -> the instrument reference
   * is used as-is (unchanged legacy behavior). Same table and same field
   * name/semantics as Reduce.quote_currency — one concept, one name, on both
   * messages. Deliberately NOT settlement_currency (that names an option
   * contract's own settlement, a different concept).
   */
  quoteCurrency?: string | undefined
}

export interface Reduce {
  /**
   * Reduce is always emitted reduce-only. There is intentionally no shared
   * Action.reduce_only flag; use Reduce to close or shrink existing exposure.
   */
  position: PositionRef | undefined
  amount: Amount | undefined
  executionStyle: ExecutionStyle | undefined
  /**
   * Venue-native stop-loss / take-profit trigger, emitted directly as
   * execution.NewOrderParams.trigger_condition with reduce_only=true.
   */
  triggerCondition?: TriggerCondition | undefined
  /**
   * Desired quote currency for a spot sell (e.g. "KRW", "USDT"). Only valid
   * with the `asset` position selector (a concrete instrument symbol already
   * pins the pair). Absent -> the compiler applies the per-venue default
   * preference when the reduce resolves to spot. Refused if set on a Reduce
   * that resolves to a derivative position (spot-only; the compiler rejects
   * rather than silently ignoring it). Same name and semantics as
   * Acquire.quote_currency — one concept, one name, matching the existing
   * instrument.quote_currency terminology.
   *
   * Safety scope: the `asset` selector auto-routes to spot only when the
   * account holds zero open derivative positions in THIS SAME asset — it
   * does not reason about cross-asset margin. On a cross/portfolio-margin
   * venue, a balance in this asset can still be backing collateral for a
   * position in a DIFFERENT asset; whether that's caught depends on the
   * venue's own available-quantity reporting (portfolio-aware on Deribit;
   * not on Bybit UNIFIED accounts today). Callers that need certainty here
   * should target the position/order explicitly rather than relying on the
   * bare asset selector.
   */
  quoteCurrency?: string | undefined
}

/**
 * Roll preserves the source instrument kind and option type; it only moves the
 * position to a new expiry (and, optionally, a new strike). A call-to-put or
 * put-to-call change should be represented as Reduce + Acquire instead.
 * Currently options-only: the compiler closes the source reduce-only and opens
 * the derived target, both legs in the same batch (no atomic guarantee).
 * `target_strike` is optional — when omitted the source strike is kept — and
 * supports absolute strikes only (delta/moneyness are not yet wired up).
 */
export interface Roll {
  /**
   * Must resolve to one singular existing position. `asset`, `dust`, and
   * `all_positions` selectors are invalid here; use explicit position_id or a
   * single instrument reference.
   */
  sourcePosition: PositionRef | undefined
  targetExpiry: ExpirySpec | undefined
  targetStrike?: StrikeSpec | undefined
  amount: Amount | undefined
  closeStyle: ExecutionStyle | undefined
  openStyle: ExecutionStyle | undefined
}

/**
 * One-shot delta hedge: computes the account's CURRENT aggregate delta for
 * `scope` once, against a point-in-time snapshot, and emits a single order
 * sized to bring it to `target` (default 0). Unlike `HedgeSubscription` this
 * is not a running algo — no band ladder, no ongoing monitoring; the caller
 * gets one concrete order to review and confirm through the normal draft-plan
 * path. Unlike `HedgeSubscription.hedge_instrument` (spot/perp only), an
 * option selector IS supported here — the compiler sizes the order using that
 * option's own current per-contract delta.
 */
export interface SingleHedge {
  scope: HedgeScope | undefined
  /**
   * Instrument the resulting order trades. Omit for the default per-underlying
   * perp (same default as HedgeSubscription).
   */
  hedgeInstrument?: InstrumentRef | undefined
  /** Signed delta to bring the scope to. Omit to flatten to zero. */
  target?: DeltaTarget | undefined
  /**
   * How the resulting order executes. Omit to let the compiler auto-pick
   * MARKET (small size) or TWAP (large size, using the same
   * large_order_base_threshold / large_order_quote_threshold config the
   * large-order advisory warning already uses).
   */
  executionStyle?: ExecutionStyle | undefined
}

export interface DeltaTarget {
  /** Signed delta. */
  value: string
  /** Required when `target` is set. */
  denomination: DeltaDenomination
}

/**
 * `delta_bands` is required: `acceptable` plus at least one priority band must
 * be present (the compiler does not invent thresholds). `hedge_instrument` is
 * optional; when absent, the compiler derives the default perp for each resolved
 * underlying.
 */
export interface HedgeSubscription {
  scope: HedgeScope | undefined
  deltaBands: HedgeDeltaBands | undefined
  /**
   * When absent, positive-gamma treatment is OFF (there is no configured
   * default; the compiler passes the absence through unchanged).
   */
  positiveGammaTreatment?: boolean | undefined
  /**
   * Instrument the algo trades to neutralise delta. Optional; omit for the
   * default per-underlying perp. Supplying a mismatched instrument for a
   * single-underlying hedge is refused.
   */
  hedgeInstrument: InstrumentRef | undefined
  /**
   * Replace an overlapping active hedge instead of refusing. Passed through to
   * HedgeAlgoParams.replace_overlapping; the algo service performs the handoff.
   */
  replaceOverlapping?: boolean | undefined
  deltaStream?: DeltaStreamHedgeMode | undefined
  interval?: IntervalHedgeMode | undefined
}

export interface DeltaStreamHedgeMode {
  minReevalMs?: string | undefined
}

export interface IntervalHedgeMode {
  intervalSeconds: string
}

export interface HedgeScope {
  portfolio?: PortfolioScope | undefined
  /** For a single-position scope, use `position_group` with one entry. */
  positionGroup?: PositionGroupScope | undefined
}

export interface PortfolioScope {
  /** Absent means whole portfolio. Present scopes to one underlying sub-book. */
  underlying?: AssetRef | undefined
}

export interface PositionGroupScope {
  /**
   * For asset-wide scoping use `PortfolioScope.underlying` — `asset` is not
   * permitted here. `dust` / `all_positions` are also rejected.
   */
  positions: SingularPositionRef[]
  /** Telemetry/UX only; not load-bearing. */
  label?: string | undefined
}

/**
 * Singular position reference used where group/expansion semantics are
 * invalid (e.g. hedge scope entries). Excludes `asset`, `dust`, and
 * `all_positions` — those are expansion selectors, not singular positions.
 */
export interface SingularPositionRef {
  instrument?: InstrumentRef | undefined
}

/**
 * When `acceptable` is absent, the compiler fills the per-underlying
 * default band. Absence on the parent `HedgeSubscription.delta_bands`
 * already implies whole-default; this nested optionality lets the AI
 * override priority bands while leaving `acceptable` at default.
 */
export interface HedgeDeltaBands {
  acceptable?: DeltaBand | undefined
  maxLowPriority?: PriorityDeltaBand | undefined
  maxMediumPriority?: PriorityDeltaBand | undefined
  maxHighPriority?: PriorityDeltaBand | undefined
  minLowPriority?: PriorityDeltaBand | undefined
  minMediumPriority?: PriorityDeltaBand | undefined
  minHighPriority?: PriorityDeltaBand | undefined
  /** Bands are denominated in either signed underlying delta units or USD delta. */
  denomination: DeltaDenomination
}

export interface DeltaBand {
  /** Signed delta lower bound. */
  from: string
  /** Signed delta upper bound. */
  to: string
  /** Delta target after exiting the band. */
  target: string
}

export interface PriorityDeltaBand {
  from: string
  to: string
  target: string
  hedgingMechanism: ExecutionStyle | undefined
}

/**
 * `price`, `time_in_force`, `post_only` are LIMIT-only (refused on market
 * with `UNSUPPORTED_STRUCTURE`). `reduce_only` is immutable post-placement
 * on most venues — cancel + replace instead.
 */
export interface UpdateOrder {
  orderId: string
  quantity?: UpdateOrderQuantity | undefined
  price?: PriceSpec | undefined
  timeInForce?: TimeInForce | undefined
  postOnly?: boolean | undefined
  reduceOnly?: boolean | undefined
}

export interface UpdateOrderQuantity {
  /** Replaces the current order quantity with this absolute amount. */
  absolute?: Amount | undefined
  /**
   * Adds to or subtracts from the current open-order quantity after the
   * compiler looks up the order.
   */
  delta?: QuantityDelta | undefined
}

export interface QuantityDelta {
  direction: QuantityDeltaDirection
  /**
   * Positive amount to add/subtract. Exact base/quote are supported; percent,
   * all_available, and match_position require venue/order metadata and are
   * refused until supported explicitly.
   */
  amount: Amount | undefined
}

export interface CancelOrder {
  orderId: string
  reason?: string | undefined
}

export interface CancelAlgo {
  algoId: string
  reason?: string | undefined
}

export interface CancelAllOrders {
  /**
   * Absent scope cancels all open orders for the account. Present scope limits
   * cancellation to matching instrument orders, e.g. all BTC orders.
   */
  scope?: InstrumentRef | undefined
  reason?: string | undefined
}

/**
 * Flattened leaf-value encoding (discriminator + scalar/leaf fields), NOT a
 * oneof — see docs/intent-compiler-proto-shape-rules.md. `ExecutionStyle`
 * answers "how should this execute?". Per-kind required/forbidden field rules
 * are enforced in intent-compiler validation, not structurally.
 *
 * `limit_price`, `time_in_force` are LIMIT-only; `post_only` is LIMIT or
 * SCALE. `twap_*` are TWAP-only. `starting_price` is LIMIT_CHASE-only.
 * `scale_*` are SCALE-only. For a true market order use
 * kind = MARKET, not a LIMIT/TWAP with a "market price" PriceSpec.
 */
export interface ExecutionStyle {
  kind: ExecutionStyleKind
  /** LIMIT only. Required for LIMIT. */
  limitPrice?: PriceSpec | undefined
  /** LIMIT only. */
  timeInForce?: TimeInForce | undefined
  /** LIMIT or SCALE. */
  postOnly?: boolean | undefined
  /**
   * TWAP only. Required for TWAP and must be > 0. The compiler chooses sane
   * slicing defaults from this duration.
   */
  twapDurationSeconds?: string | undefined
  /** TWAP only. Optional absolute limit cap. */
  twapLimitPrice?: PriceSpec | undefined
  /** LIMIT_CHASE only. Optional starting price. */
  startingPrice?: PriceSpec | undefined
  /**
   * SCALE only. Required. The two ends of the ladder; which end is nearest the
   * touch is derived from the side. `post_only` (4) applies to SCALE too.
   */
  scaleRange?: PriceBand | undefined
  /** SCALE only. Required, 2..=50. */
  scaleOrderCount?: number | undefined
  /** SCALE only. Far level's size divided by the near level's, > 0. Absent = 1. */
  scaleSizeRatio?: string | undefined
}

/**
 * Flattened leaf-value encoding (discriminator + scalar fields), NOT a oneof —
 * see docs/intent-compiler-proto-shape-rules.md. `Amount` answers "how much?".
 * Cross-field rules are enforced in intent-compiler validation, not
 * structurally. MATCH_POSITION carries an opaque scalar `match_position_key`
 * (NOT a PositionRef) to avoid reintroducing structural reference fan-out.
 *
 * `value`'s meaning depends on `kind`. EXACT_BASE: base-currency units (BTC,
 * ETH). EXACT_QUOTE: quote-currency amount actually spent (linear/spot: quote
 * units like USDT; inverse perps: USD-fixed contract chunks; options: premium
 * in the settlement currency). Mixing axes is a refusal — EXACT_QUOTE on a
 * base-only sizing callsite is `REFUSAL_REASON_UNSUPPORTED_STRUCTURE`.
 */
export interface Amount {
  kind: AmountKind
  /**
   * Decimal string. Required for EXACT_BASE, EXACT_QUOTE, PERCENT_POSITION,
   * PERCENT_PORTFOLIO. Must be absent for ALL_AVAILABLE and MATCH_POSITION.
   * Percent kinds are percentage points: "50" = 50%, "0.5" = 0.5%.
   */
  value?: string | undefined
  /**
   * Optional denomination for exact / all-available styles where meaningful.
   * Forbidden for percent styles and MATCH_POSITION.
   */
  currency?: string | undefined
  /**
   * Opaque key from the account/portfolio snapshot identifying one singular
   * existing position. Required only for MATCH_POSITION; resolved by the
   * compiler against the account snapshot, and refused if it does not resolve
   * to exactly one position. Intentionally NOT a PositionRef — keep it scalar.
   */
  matchPositionKey?: string | undefined
  /**
   * Required only for MATCH_POSITION; forbidden otherwise. "Match my ETH
   * position" is ambiguous until the AI/user states whether to match USD
   * notional, base quantity, or delta.
   */
  matchBasis?: MatchPositionBasis | undefined
  /**
   * Index into the enclosing create_rfq.legs list naming the leg whose
   * mark-value this leg is sized to match. Required only for MATCH_LEG;
   * forbidden otherwise. See AMOUNT_KIND_MATCH_LEG; v1 gate enforced in
   * intent-compiler validation.
   */
  matchLegIndex?: number | undefined
}

export interface InstrumentRef {
  symbol?: string | undefined
  option?: OptionSelector | undefined
}

/**
 * Call sites validate which variants are meaningful. `dust` and
 * `all_positions` are expansion selectors for reduce-style flows and are
 * invalid where a singular position is required.
 */
export interface PositionRef {
  positionId?: string | undefined
  instrument?: InstrumentRef | undefined
  asset?: AssetRef | undefined
  dust?: DustSelector | undefined
  allPositions?: AllPositions | undefined
}

export interface DustSelector {}

export interface AllPositions {}

/**
 * For a true market order, use `ExecutionStyle.market` — not a limit/TWAP
 * with a "market price" PriceSpec. For dynamic mark-anchored pricing within
 * a limit-style route, use `RelativePrice { anchor = MARK_PRICE, offset = 0 }`.
 */
export interface PriceSpec {
  absolute?: string | undefined
  relative?: RelativePrice | undefined
  band?: PriceBand | undefined
}

export interface PriceBand {
  minPrice: PriceBound | undefined
  maxPrice: PriceBound | undefined
}

/**
 * A floating bound (MarketPrice) is meaningless here — bounds are static
 * thresholds. For "current mid as a bound" use `RelativePrice` with offset 0.
 */
export interface PriceBound {
  absolute?: string | undefined
  relative?: RelativePrice | undefined
}

export interface RelativePrice {
  anchor: PriceReference
  offset: string
  offsetUnit: PriceOffsetUnit
}

export interface OptionSelector {
  underlying: AssetRef | undefined
  optionType: OptionType
  expiry: ExpirySpec | undefined
  strike: StrikeSpec | undefined
  /**
   * Settlement currency of the desired option line (e.g. "BTC" for
   * coin-settled, "USDC", "USDT"). Empty: the resolver applies the
   * per-exchange default preference (Deribit: coin-settled first;
   * Bybit: USDC first).
   */
  settlementCurrency: string
}

export interface StrikeSpec {
  absolute?: string | undefined
  /**
   * Signed option delta as a unit interval, not percent. Calls are positive,
   * puts are negative. Examples: "0.25" for a 25-delta call, "-0.25" for a
   * 25-delta put.
   */
  delta?: string | undefined
  /**
   * Signed percent OTM relative to spot/ATM (positive = OTM in the
   * call/put direction implied by the surrounding OptionSelector).
   */
  moneynessPercent?: string | undefined
}

export interface ExpirySpec {
  unixMs?: string | undefined
  /**
   * YYYY-MM-DD in the venue's settlement timezone; resolves to the venue's
   * settlement instant on that date. Refused with `INVALID_EXPIRY` when no
   * listed contract matches.
   */
  date?: string | undefined
  /**
   * Relative expiry selector from compiler evaluation time. Example:
   * value=2, unit=TENOR_UNIT_WEEKS means "about two weeks out".
   */
  tenor?: TenorSpec | undefined
  nearest?: NearestExpiry | undefined
}

export interface TenorSpec {
  /** Positive duration amount in the selected unit. */
  value: number
  unit: TenorUnit
}

export interface NearestExpiry {
  /** Calendar-day window from compiler evaluation time. */
  minDays?: string | undefined
  maxDays?: string | undefined
}

/**
 * ── Test surface ──────────────────────────────────────────────────────────
 * TestIntentCompilerRequest drives the intent-compiler with a fully
 * caller-supplied account snapshot, with no live backend. It compiles a draft
 * only (execution still requires the authenticated ConfirmExecutionPlan path),
 * so the public-api endpoint that carries it is intentionally unauthenticated.
 */
export interface TestIntentCompilerRequest {
  intent: TradeIntent | undefined
  snapshot: TestAccountSnapshot | undefined
  /** Defaults to the compiler's configured storage exchange when omitted. */
  storageExchange?: string | undefined
}

export interface TestAccountSnapshot {
  balances: PortfolioData[]
  positions: TestPosition[]
  openOrders: Order[]
  algoStates: AlgoState[]
  /**
   * Instrument-universe fixture. Without this, every Roll and SingleHedge
   * action refuses RequiredDataUnavailable, and every option selector
   * refuses UnresolvableReference.
   */
  instruments: Instrument[]
  /**
   * Mark-price fixture for sizing paths that need current marks (MATCH_LEG
   * legs). Without it those paths refuse RequiredDataUnavailable. Fixture
   * tickers are treated as fresh at compile time. Delta/moneyness strike
   * selectors need fuller live tickers and are not covered.
   */
  tickers: TestTicker[]
}

export interface TestTicker {
  symbol: string
  /** decimal string, must parse and be > 0 */
  markPrice: string
}

/**
 * Lean position input — exactly the fields the compiler reads. The canonical
 * common.trading.Position carries ~30 derived fields (avg/mark price, greeks,
 * expiry, strike, _usd/_base metrics) that compile logic never touches.
 */
export interface TestPosition {
  /** matched case-insensitively */
  symbol: string
  /** signed decimal as string; zero-qty rows are ignored */
  quantity: string
  /** required to compile a Reduce; UNSPECIFIED -> refusal */
  side: OrderSide
  /** BASE/QUOTE; required for Reduce sizing */
  sizeDenomination: Denomination
}

function createBaseTradeIntent(): TradeIntent {
  return { accountId: '', actions: [], algoSubscriptions: [], management: [] }
}

export const TradeIntent: MessageFns<TradeIntent> = {
  encode(message: TradeIntent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    for (const v of message.actions) {
      Action.encode(v!, writer.uint32(18).fork()).join()
    }
    for (const v of message.algoSubscriptions) {
      AlgoSubscription.encode(v!, writer.uint32(26).fork()).join()
    }
    for (const v of message.management) {
      Management.encode(v!, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TradeIntent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTradeIntent()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.actions.push(Action.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.algoSubscriptions.push(AlgoSubscription.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.management.push(Management.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TradeIntent {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      actions: globalThis.Array.isArray(object?.actions)
        ? object.actions.map((e: any) => Action.fromJSON(e))
        : [],
      algoSubscriptions: globalThis.Array.isArray(object?.algoSubscriptions)
        ? object.algoSubscriptions.map((e: any) => AlgoSubscription.fromJSON(e))
        : globalThis.Array.isArray(object?.algo_subscriptions)
          ? object.algo_subscriptions.map((e: any) => AlgoSubscription.fromJSON(e))
          : [],
      management: globalThis.Array.isArray(object?.management)
        ? object.management.map((e: any) => Management.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TradeIntent): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.actions?.length) {
      obj.actions = message.actions.map((e) => Action.toJSON(e))
    }
    if (message.algoSubscriptions?.length) {
      obj.algoSubscriptions = message.algoSubscriptions.map((e) => AlgoSubscription.toJSON(e))
    }
    if (message.management?.length) {
      obj.management = message.management.map((e) => Management.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TradeIntent>, I>>(base?: I): TradeIntent {
    return TradeIntent.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TradeIntent>, I>>(object: I): TradeIntent {
    const message = createBaseTradeIntent()
    message.accountId = object.accountId ?? ''
    message.actions = object.actions?.map((e) => Action.fromPartial(e)) || []
    message.algoSubscriptions =
      object.algoSubscriptions?.map((e) => AlgoSubscription.fromPartial(e)) || []
    message.management = object.management?.map((e) => Management.fromPartial(e)) || []
    return message
  },
}

function createBaseAction(): Action {
  return {
    trigger: undefined,
    allowExecutionStyleUpgrade: undefined,
    acquire: undefined,
    reduce: undefined,
    roll: undefined,
    createRfq: undefined,
    singleHedge: undefined,
  }
}

export const Action: MessageFns<Action> = {
  encode(message: Action, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.trigger !== undefined) {
      Trigger.encode(message.trigger, writer.uint32(10).fork()).join()
    }
    if (message.allowExecutionStyleUpgrade !== undefined) {
      writer.uint32(16).bool(message.allowExecutionStyleUpgrade)
    }
    if (message.acquire !== undefined) {
      Acquire.encode(message.acquire, writer.uint32(82).fork()).join()
    }
    if (message.reduce !== undefined) {
      Reduce.encode(message.reduce, writer.uint32(90).fork()).join()
    }
    if (message.roll !== undefined) {
      Roll.encode(message.roll, writer.uint32(114).fork()).join()
    }
    if (message.createRfq !== undefined) {
      CreateRfq.encode(message.createRfq, writer.uint32(122).fork()).join()
    }
    if (message.singleHedge !== undefined) {
      SingleHedge.encode(message.singleHedge, writer.uint32(130).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Action {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAction()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.trigger = Trigger.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.allowExecutionStyleUpgrade = reader.bool()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.acquire = Acquire.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.reduce = Reduce.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.roll = Roll.decode(reader, reader.uint32())
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.createRfq = CreateRfq.decode(reader, reader.uint32())
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.singleHedge = SingleHedge.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Action {
    return {
      trigger: isSet(object.trigger) ? Trigger.fromJSON(object.trigger) : undefined,
      allowExecutionStyleUpgrade: isSet(object.allowExecutionStyleUpgrade)
        ? globalThis.Boolean(object.allowExecutionStyleUpgrade)
        : isSet(object.allow_execution_style_upgrade)
          ? globalThis.Boolean(object.allow_execution_style_upgrade)
          : undefined,
      acquire: isSet(object.acquire) ? Acquire.fromJSON(object.acquire) : undefined,
      reduce: isSet(object.reduce) ? Reduce.fromJSON(object.reduce) : undefined,
      roll: isSet(object.roll) ? Roll.fromJSON(object.roll) : undefined,
      createRfq: isSet(object.createRfq)
        ? CreateRfq.fromJSON(object.createRfq)
        : isSet(object.create_rfq)
          ? CreateRfq.fromJSON(object.create_rfq)
          : undefined,
      singleHedge: isSet(object.singleHedge)
        ? SingleHedge.fromJSON(object.singleHedge)
        : isSet(object.single_hedge)
          ? SingleHedge.fromJSON(object.single_hedge)
          : undefined,
    }
  },

  toJSON(message: Action): unknown {
    const obj: any = {}
    if (message.trigger !== undefined) {
      obj.trigger = Trigger.toJSON(message.trigger)
    }
    if (message.allowExecutionStyleUpgrade !== undefined) {
      obj.allowExecutionStyleUpgrade = message.allowExecutionStyleUpgrade
    }
    if (message.acquire !== undefined) {
      obj.acquire = Acquire.toJSON(message.acquire)
    }
    if (message.reduce !== undefined) {
      obj.reduce = Reduce.toJSON(message.reduce)
    }
    if (message.roll !== undefined) {
      obj.roll = Roll.toJSON(message.roll)
    }
    if (message.createRfq !== undefined) {
      obj.createRfq = CreateRfq.toJSON(message.createRfq)
    }
    if (message.singleHedge !== undefined) {
      obj.singleHedge = SingleHedge.toJSON(message.singleHedge)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Action>, I>>(base?: I): Action {
    return Action.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Action>, I>>(object: I): Action {
    const message = createBaseAction()
    message.trigger =
      object.trigger !== undefined && object.trigger !== null
        ? Trigger.fromPartial(object.trigger)
        : undefined
    message.allowExecutionStyleUpgrade = object.allowExecutionStyleUpgrade ?? undefined
    message.acquire =
      object.acquire !== undefined && object.acquire !== null
        ? Acquire.fromPartial(object.acquire)
        : undefined
    message.reduce =
      object.reduce !== undefined && object.reduce !== null
        ? Reduce.fromPartial(object.reduce)
        : undefined
    message.roll =
      object.roll !== undefined && object.roll !== null ? Roll.fromPartial(object.roll) : undefined
    message.createRfq =
      object.createRfq !== undefined && object.createRfq !== null
        ? CreateRfq.fromPartial(object.createRfq)
        : undefined
    message.singleHedge =
      object.singleHedge !== undefined && object.singleHedge !== null
        ? SingleHedge.fromPartial(object.singleHedge)
        : undefined
    return message
  },
}

function createBaseAlgoSubscription(): AlgoSubscription {
  return { trigger: undefined, allowExecutionStyleUpgrade: undefined, hedge: undefined }
}

export const AlgoSubscription: MessageFns<AlgoSubscription> = {
  encode(message: AlgoSubscription, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.trigger !== undefined) {
      Trigger.encode(message.trigger, writer.uint32(10).fork()).join()
    }
    if (message.allowExecutionStyleUpgrade !== undefined) {
      writer.uint32(16).bool(message.allowExecutionStyleUpgrade)
    }
    if (message.hedge !== undefined) {
      HedgeSubscription.encode(message.hedge, writer.uint32(82).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlgoSubscription {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAlgoSubscription()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.trigger = Trigger.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.allowExecutionStyleUpgrade = reader.bool()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.hedge = HedgeSubscription.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AlgoSubscription {
    return {
      trigger: isSet(object.trigger) ? Trigger.fromJSON(object.trigger) : undefined,
      allowExecutionStyleUpgrade: isSet(object.allowExecutionStyleUpgrade)
        ? globalThis.Boolean(object.allowExecutionStyleUpgrade)
        : isSet(object.allow_execution_style_upgrade)
          ? globalThis.Boolean(object.allow_execution_style_upgrade)
          : undefined,
      hedge: isSet(object.hedge) ? HedgeSubscription.fromJSON(object.hedge) : undefined,
    }
  },

  toJSON(message: AlgoSubscription): unknown {
    const obj: any = {}
    if (message.trigger !== undefined) {
      obj.trigger = Trigger.toJSON(message.trigger)
    }
    if (message.allowExecutionStyleUpgrade !== undefined) {
      obj.allowExecutionStyleUpgrade = message.allowExecutionStyleUpgrade
    }
    if (message.hedge !== undefined) {
      obj.hedge = HedgeSubscription.toJSON(message.hedge)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AlgoSubscription>, I>>(base?: I): AlgoSubscription {
    return AlgoSubscription.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AlgoSubscription>, I>>(object: I): AlgoSubscription {
    const message = createBaseAlgoSubscription()
    message.trigger =
      object.trigger !== undefined && object.trigger !== null
        ? Trigger.fromPartial(object.trigger)
        : undefined
    message.allowExecutionStyleUpgrade = object.allowExecutionStyleUpgrade ?? undefined
    message.hedge =
      object.hedge !== undefined && object.hedge !== null
        ? HedgeSubscription.fromPartial(object.hedge)
        : undefined
    return message
  },
}

function createBaseManagement(): Management {
  return {
    trigger: undefined,
    updateOrder: undefined,
    cancelOrder: undefined,
    cancelAlgo: undefined,
    cancelAllOrders: undefined,
    cancelRfq: undefined,
  }
}

export const Management: MessageFns<Management> = {
  encode(message: Management, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.trigger !== undefined) {
      Trigger.encode(message.trigger, writer.uint32(10).fork()).join()
    }
    if (message.updateOrder !== undefined) {
      UpdateOrder.encode(message.updateOrder, writer.uint32(82).fork()).join()
    }
    if (message.cancelOrder !== undefined) {
      CancelOrder.encode(message.cancelOrder, writer.uint32(90).fork()).join()
    }
    if (message.cancelAlgo !== undefined) {
      CancelAlgo.encode(message.cancelAlgo, writer.uint32(98).fork()).join()
    }
    if (message.cancelAllOrders !== undefined) {
      CancelAllOrders.encode(message.cancelAllOrders, writer.uint32(106).fork()).join()
    }
    if (message.cancelRfq !== undefined) {
      CancelRfq.encode(message.cancelRfq, writer.uint32(114).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Management {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseManagement()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.trigger = Trigger.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.updateOrder = UpdateOrder.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.cancelOrder = CancelOrder.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.cancelAlgo = CancelAlgo.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.cancelAllOrders = CancelAllOrders.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.cancelRfq = CancelRfq.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Management {
    return {
      trigger: isSet(object.trigger) ? Trigger.fromJSON(object.trigger) : undefined,
      updateOrder: isSet(object.updateOrder)
        ? UpdateOrder.fromJSON(object.updateOrder)
        : isSet(object.update_order)
          ? UpdateOrder.fromJSON(object.update_order)
          : undefined,
      cancelOrder: isSet(object.cancelOrder)
        ? CancelOrder.fromJSON(object.cancelOrder)
        : isSet(object.cancel_order)
          ? CancelOrder.fromJSON(object.cancel_order)
          : undefined,
      cancelAlgo: isSet(object.cancelAlgo)
        ? CancelAlgo.fromJSON(object.cancelAlgo)
        : isSet(object.cancel_algo)
          ? CancelAlgo.fromJSON(object.cancel_algo)
          : undefined,
      cancelAllOrders: isSet(object.cancelAllOrders)
        ? CancelAllOrders.fromJSON(object.cancelAllOrders)
        : isSet(object.cancel_all_orders)
          ? CancelAllOrders.fromJSON(object.cancel_all_orders)
          : undefined,
      cancelRfq: isSet(object.cancelRfq)
        ? CancelRfq.fromJSON(object.cancelRfq)
        : isSet(object.cancel_rfq)
          ? CancelRfq.fromJSON(object.cancel_rfq)
          : undefined,
    }
  },

  toJSON(message: Management): unknown {
    const obj: any = {}
    if (message.trigger !== undefined) {
      obj.trigger = Trigger.toJSON(message.trigger)
    }
    if (message.updateOrder !== undefined) {
      obj.updateOrder = UpdateOrder.toJSON(message.updateOrder)
    }
    if (message.cancelOrder !== undefined) {
      obj.cancelOrder = CancelOrder.toJSON(message.cancelOrder)
    }
    if (message.cancelAlgo !== undefined) {
      obj.cancelAlgo = CancelAlgo.toJSON(message.cancelAlgo)
    }
    if (message.cancelAllOrders !== undefined) {
      obj.cancelAllOrders = CancelAllOrders.toJSON(message.cancelAllOrders)
    }
    if (message.cancelRfq !== undefined) {
      obj.cancelRfq = CancelRfq.toJSON(message.cancelRfq)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Management>, I>>(base?: I): Management {
    return Management.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Management>, I>>(object: I): Management {
    const message = createBaseManagement()
    message.trigger =
      object.trigger !== undefined && object.trigger !== null
        ? Trigger.fromPartial(object.trigger)
        : undefined
    message.updateOrder =
      object.updateOrder !== undefined && object.updateOrder !== null
        ? UpdateOrder.fromPartial(object.updateOrder)
        : undefined
    message.cancelOrder =
      object.cancelOrder !== undefined && object.cancelOrder !== null
        ? CancelOrder.fromPartial(object.cancelOrder)
        : undefined
    message.cancelAlgo =
      object.cancelAlgo !== undefined && object.cancelAlgo !== null
        ? CancelAlgo.fromPartial(object.cancelAlgo)
        : undefined
    message.cancelAllOrders =
      object.cancelAllOrders !== undefined && object.cancelAllOrders !== null
        ? CancelAllOrders.fromPartial(object.cancelAllOrders)
        : undefined
    message.cancelRfq =
      object.cancelRfq !== undefined && object.cancelRfq !== null
        ? CancelRfq.fromPartial(object.cancelRfq)
        : undefined
    return message
  },
}

function createBaseCreateRfq(): CreateRfq {
  return {
    legs: [],
    hedge: undefined,
    makerIds: [],
    disclosed: undefined,
    autoApprove: undefined,
    autoRetry: undefined,
  }
}

export const CreateRfq: MessageFns<CreateRfq> = {
  encode(message: CreateRfq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.legs) {
      RfqIntentLeg.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.hedge !== undefined) {
      RfqIntentHedge.encode(message.hedge, writer.uint32(18).fork()).join()
    }
    for (const v of message.makerIds) {
      writer.uint32(26).string(v!)
    }
    if (message.disclosed !== undefined) {
      writer.uint32(32).bool(message.disclosed)
    }
    if (message.autoApprove !== undefined) {
      AutoApprove.encode(message.autoApprove, writer.uint32(42).fork()).join()
    }
    if (message.autoRetry !== undefined) {
      AutoRetry.encode(message.autoRetry, writer.uint32(50).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateRfq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreateRfq()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.legs.push(RfqIntentLeg.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.hedge = RfqIntentHedge.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.makerIds.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.disclosed = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.autoApprove = AutoApprove.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.autoRetry = AutoRetry.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreateRfq {
    return {
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => RfqIntentLeg.fromJSON(e))
        : [],
      hedge: isSet(object.hedge) ? RfqIntentHedge.fromJSON(object.hedge) : undefined,
      makerIds: globalThis.Array.isArray(object?.makerIds)
        ? object.makerIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.maker_ids)
          ? object.maker_ids.map((e: any) => globalThis.String(e))
          : [],
      disclosed: isSet(object.disclosed) ? globalThis.Boolean(object.disclosed) : undefined,
      autoApprove: isSet(object.autoApprove)
        ? AutoApprove.fromJSON(object.autoApprove)
        : isSet(object.auto_approve)
          ? AutoApprove.fromJSON(object.auto_approve)
          : undefined,
      autoRetry: isSet(object.autoRetry)
        ? AutoRetry.fromJSON(object.autoRetry)
        : isSet(object.auto_retry)
          ? AutoRetry.fromJSON(object.auto_retry)
          : undefined,
    }
  },

  toJSON(message: CreateRfq): unknown {
    const obj: any = {}
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => RfqIntentLeg.toJSON(e))
    }
    if (message.hedge !== undefined) {
      obj.hedge = RfqIntentHedge.toJSON(message.hedge)
    }
    if (message.makerIds?.length) {
      obj.makerIds = message.makerIds
    }
    if (message.disclosed !== undefined) {
      obj.disclosed = message.disclosed
    }
    if (message.autoApprove !== undefined) {
      obj.autoApprove = AutoApprove.toJSON(message.autoApprove)
    }
    if (message.autoRetry !== undefined) {
      obj.autoRetry = AutoRetry.toJSON(message.autoRetry)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreateRfq>, I>>(base?: I): CreateRfq {
    return CreateRfq.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreateRfq>, I>>(object: I): CreateRfq {
    const message = createBaseCreateRfq()
    message.legs = object.legs?.map((e) => RfqIntentLeg.fromPartial(e)) || []
    message.hedge =
      object.hedge !== undefined && object.hedge !== null
        ? RfqIntentHedge.fromPartial(object.hedge)
        : undefined
    message.makerIds = object.makerIds?.map((e) => e) || []
    message.disclosed = object.disclosed ?? undefined
    message.autoApprove =
      object.autoApprove !== undefined && object.autoApprove !== null
        ? AutoApprove.fromPartial(object.autoApprove)
        : undefined
    message.autoRetry =
      object.autoRetry !== undefined && object.autoRetry !== null
        ? AutoRetry.fromPartial(object.autoRetry)
        : undefined
    return message
  },
}

function createBaseRfqIntentLeg(): RfqIntentLeg {
  return { instrument: undefined, amount: undefined, side: 0 }
}

export const RfqIntentLeg: MessageFns<RfqIntentLeg> = {
  encode(message: RfqIntentLeg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instrument !== undefined) {
      InstrumentRef.encode(message.instrument, writer.uint32(10).fork()).join()
    }
    if (message.amount !== undefined) {
      Amount.encode(message.amount, writer.uint32(18).fork()).join()
    }
    if (message.side !== 0) {
      writer.uint32(24).int32(message.side)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqIntentLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqIntentLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrument = InstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.amount = Amount.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqIntentLeg {
    return {
      instrument: isSet(object.instrument) ? InstrumentRef.fromJSON(object.instrument) : undefined,
      amount: isSet(object.amount) ? Amount.fromJSON(object.amount) : undefined,
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
    }
  },

  toJSON(message: RfqIntentLeg): unknown {
    const obj: any = {}
    if (message.instrument !== undefined) {
      obj.instrument = InstrumentRef.toJSON(message.instrument)
    }
    if (message.amount !== undefined) {
      obj.amount = Amount.toJSON(message.amount)
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqIntentLeg>, I>>(base?: I): RfqIntentLeg {
    return RfqIntentLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqIntentLeg>, I>>(object: I): RfqIntentLeg {
    const message = createBaseRfqIntentLeg()
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? InstrumentRef.fromPartial(object.instrument)
        : undefined
    message.amount =
      object.amount !== undefined && object.amount !== null
        ? Amount.fromPartial(object.amount)
        : undefined
    message.side = object.side ?? 0
    return message
  },
}

function createBaseRfqIntentHedge(): RfqIntentHedge {
  return { instrument: undefined, amount: undefined, side: 0, price: undefined }
}

export const RfqIntentHedge: MessageFns<RfqIntentHedge> = {
  encode(message: RfqIntentHedge, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instrument !== undefined) {
      InstrumentRef.encode(message.instrument, writer.uint32(10).fork()).join()
    }
    if (message.amount !== undefined) {
      Amount.encode(message.amount, writer.uint32(18).fork()).join()
    }
    if (message.side !== 0) {
      writer.uint32(24).int32(message.side)
    }
    if (message.price !== undefined) {
      PriceSpec.encode(message.price, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RfqIntentHedge {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRfqIntentHedge()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrument = InstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.amount = Amount.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.price = PriceSpec.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RfqIntentHedge {
    return {
      instrument: isSet(object.instrument) ? InstrumentRef.fromJSON(object.instrument) : undefined,
      amount: isSet(object.amount) ? Amount.fromJSON(object.amount) : undefined,
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      price: isSet(object.price) ? PriceSpec.fromJSON(object.price) : undefined,
    }
  },

  toJSON(message: RfqIntentHedge): unknown {
    const obj: any = {}
    if (message.instrument !== undefined) {
      obj.instrument = InstrumentRef.toJSON(message.instrument)
    }
    if (message.amount !== undefined) {
      obj.amount = Amount.toJSON(message.amount)
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.price !== undefined) {
      obj.price = PriceSpec.toJSON(message.price)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RfqIntentHedge>, I>>(base?: I): RfqIntentHedge {
    return RfqIntentHedge.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RfqIntentHedge>, I>>(object: I): RfqIntentHedge {
    const message = createBaseRfqIntentHedge()
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? InstrumentRef.fromPartial(object.instrument)
        : undefined
    message.amount =
      object.amount !== undefined && object.amount !== null
        ? Amount.fromPartial(object.amount)
        : undefined
    message.side = object.side ?? 0
    message.price =
      object.price !== undefined && object.price !== null
        ? PriceSpec.fromPartial(object.price)
        : undefined
    return message
  },
}

function createBaseCancelRfq(): CancelRfq {
  return { rfqId: '' }
}

export const CancelRfq: MessageFns<CancelRfq> = {
  encode(message: CancelRfq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rfqId !== '') {
      writer.uint32(10).string(message.rfqId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelRfq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelRfq()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.rfqId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelRfq {
    return {
      rfqId: isSet(object.rfqId)
        ? globalThis.String(object.rfqId)
        : isSet(object.rfq_id)
          ? globalThis.String(object.rfq_id)
          : '',
    }
  },

  toJSON(message: CancelRfq): unknown {
    const obj: any = {}
    if (message.rfqId !== '') {
      obj.rfqId = message.rfqId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelRfq>, I>>(base?: I): CancelRfq {
    return CancelRfq.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelRfq>, I>>(object: I): CancelRfq {
    const message = createBaseCancelRfq()
    message.rfqId = object.rfqId ?? ''
    return message
  },
}

function createBaseAcquire(): Acquire {
  return {
    instrument: undefined,
    amount: undefined,
    executionStyle: undefined,
    side: undefined,
    triggerCondition: undefined,
    quoteCurrency: undefined,
  }
}

export const Acquire: MessageFns<Acquire> = {
  encode(message: Acquire, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instrument !== undefined) {
      InstrumentRef.encode(message.instrument, writer.uint32(10).fork()).join()
    }
    if (message.amount !== undefined) {
      Amount.encode(message.amount, writer.uint32(18).fork()).join()
    }
    if (message.executionStyle !== undefined) {
      ExecutionStyle.encode(message.executionStyle, writer.uint32(26).fork()).join()
    }
    if (message.side !== undefined) {
      writer.uint32(32).int32(message.side)
    }
    if (message.triggerCondition !== undefined) {
      TriggerCondition.encode(message.triggerCondition, writer.uint32(42).fork()).join()
    }
    if (message.quoteCurrency !== undefined) {
      writer.uint32(50).string(message.quoteCurrency)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Acquire {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAcquire()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrument = InstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.amount = Amount.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.executionStyle = ExecutionStyle.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.triggerCondition = TriggerCondition.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.quoteCurrency = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Acquire {
    return {
      instrument: isSet(object.instrument) ? InstrumentRef.fromJSON(object.instrument) : undefined,
      amount: isSet(object.amount) ? Amount.fromJSON(object.amount) : undefined,
      executionStyle: isSet(object.executionStyle)
        ? ExecutionStyle.fromJSON(object.executionStyle)
        : isSet(object.execution_style)
          ? ExecutionStyle.fromJSON(object.execution_style)
          : undefined,
      side: isSet(object.side) ? orderSideFromJSON(object.side) : undefined,
      triggerCondition: isSet(object.triggerCondition)
        ? TriggerCondition.fromJSON(object.triggerCondition)
        : isSet(object.trigger_condition)
          ? TriggerCondition.fromJSON(object.trigger_condition)
          : undefined,
      quoteCurrency: isSet(object.quoteCurrency)
        ? globalThis.String(object.quoteCurrency)
        : isSet(object.quote_currency)
          ? globalThis.String(object.quote_currency)
          : undefined,
    }
  },

  toJSON(message: Acquire): unknown {
    const obj: any = {}
    if (message.instrument !== undefined) {
      obj.instrument = InstrumentRef.toJSON(message.instrument)
    }
    if (message.amount !== undefined) {
      obj.amount = Amount.toJSON(message.amount)
    }
    if (message.executionStyle !== undefined) {
      obj.executionStyle = ExecutionStyle.toJSON(message.executionStyle)
    }
    if (message.side !== undefined) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.triggerCondition !== undefined) {
      obj.triggerCondition = TriggerCondition.toJSON(message.triggerCondition)
    }
    if (message.quoteCurrency !== undefined) {
      obj.quoteCurrency = message.quoteCurrency
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Acquire>, I>>(base?: I): Acquire {
    return Acquire.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Acquire>, I>>(object: I): Acquire {
    const message = createBaseAcquire()
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? InstrumentRef.fromPartial(object.instrument)
        : undefined
    message.amount =
      object.amount !== undefined && object.amount !== null
        ? Amount.fromPartial(object.amount)
        : undefined
    message.executionStyle =
      object.executionStyle !== undefined && object.executionStyle !== null
        ? ExecutionStyle.fromPartial(object.executionStyle)
        : undefined
    message.side = object.side ?? undefined
    message.triggerCondition =
      object.triggerCondition !== undefined && object.triggerCondition !== null
        ? TriggerCondition.fromPartial(object.triggerCondition)
        : undefined
    message.quoteCurrency = object.quoteCurrency ?? undefined
    return message
  },
}

function createBaseReduce(): Reduce {
  return {
    position: undefined,
    amount: undefined,
    executionStyle: undefined,
    triggerCondition: undefined,
    quoteCurrency: undefined,
  }
}

export const Reduce: MessageFns<Reduce> = {
  encode(message: Reduce, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.position !== undefined) {
      PositionRef.encode(message.position, writer.uint32(10).fork()).join()
    }
    if (message.amount !== undefined) {
      Amount.encode(message.amount, writer.uint32(18).fork()).join()
    }
    if (message.executionStyle !== undefined) {
      ExecutionStyle.encode(message.executionStyle, writer.uint32(26).fork()).join()
    }
    if (message.triggerCondition !== undefined) {
      TriggerCondition.encode(message.triggerCondition, writer.uint32(34).fork()).join()
    }
    if (message.quoteCurrency !== undefined) {
      writer.uint32(42).string(message.quoteCurrency)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Reduce {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseReduce()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.position = PositionRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.amount = Amount.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.executionStyle = ExecutionStyle.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.triggerCondition = TriggerCondition.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.quoteCurrency = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Reduce {
    return {
      position: isSet(object.position) ? PositionRef.fromJSON(object.position) : undefined,
      amount: isSet(object.amount) ? Amount.fromJSON(object.amount) : undefined,
      executionStyle: isSet(object.executionStyle)
        ? ExecutionStyle.fromJSON(object.executionStyle)
        : isSet(object.execution_style)
          ? ExecutionStyle.fromJSON(object.execution_style)
          : undefined,
      triggerCondition: isSet(object.triggerCondition)
        ? TriggerCondition.fromJSON(object.triggerCondition)
        : isSet(object.trigger_condition)
          ? TriggerCondition.fromJSON(object.trigger_condition)
          : undefined,
      quoteCurrency: isSet(object.quoteCurrency)
        ? globalThis.String(object.quoteCurrency)
        : isSet(object.quote_currency)
          ? globalThis.String(object.quote_currency)
          : undefined,
    }
  },

  toJSON(message: Reduce): unknown {
    const obj: any = {}
    if (message.position !== undefined) {
      obj.position = PositionRef.toJSON(message.position)
    }
    if (message.amount !== undefined) {
      obj.amount = Amount.toJSON(message.amount)
    }
    if (message.executionStyle !== undefined) {
      obj.executionStyle = ExecutionStyle.toJSON(message.executionStyle)
    }
    if (message.triggerCondition !== undefined) {
      obj.triggerCondition = TriggerCondition.toJSON(message.triggerCondition)
    }
    if (message.quoteCurrency !== undefined) {
      obj.quoteCurrency = message.quoteCurrency
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Reduce>, I>>(base?: I): Reduce {
    return Reduce.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Reduce>, I>>(object: I): Reduce {
    const message = createBaseReduce()
    message.position =
      object.position !== undefined && object.position !== null
        ? PositionRef.fromPartial(object.position)
        : undefined
    message.amount =
      object.amount !== undefined && object.amount !== null
        ? Amount.fromPartial(object.amount)
        : undefined
    message.executionStyle =
      object.executionStyle !== undefined && object.executionStyle !== null
        ? ExecutionStyle.fromPartial(object.executionStyle)
        : undefined
    message.triggerCondition =
      object.triggerCondition !== undefined && object.triggerCondition !== null
        ? TriggerCondition.fromPartial(object.triggerCondition)
        : undefined
    message.quoteCurrency = object.quoteCurrency ?? undefined
    return message
  },
}

function createBaseRoll(): Roll {
  return {
    sourcePosition: undefined,
    targetExpiry: undefined,
    targetStrike: undefined,
    amount: undefined,
    closeStyle: undefined,
    openStyle: undefined,
  }
}

export const Roll: MessageFns<Roll> = {
  encode(message: Roll, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sourcePosition !== undefined) {
      PositionRef.encode(message.sourcePosition, writer.uint32(10).fork()).join()
    }
    if (message.targetExpiry !== undefined) {
      ExpirySpec.encode(message.targetExpiry, writer.uint32(18).fork()).join()
    }
    if (message.targetStrike !== undefined) {
      StrikeSpec.encode(message.targetStrike, writer.uint32(26).fork()).join()
    }
    if (message.amount !== undefined) {
      Amount.encode(message.amount, writer.uint32(34).fork()).join()
    }
    if (message.closeStyle !== undefined) {
      ExecutionStyle.encode(message.closeStyle, writer.uint32(42).fork()).join()
    }
    if (message.openStyle !== undefined) {
      ExecutionStyle.encode(message.openStyle, writer.uint32(50).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Roll {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRoll()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.sourcePosition = PositionRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.targetExpiry = ExpirySpec.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.targetStrike = StrikeSpec.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.amount = Amount.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.closeStyle = ExecutionStyle.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.openStyle = ExecutionStyle.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Roll {
    return {
      sourcePosition: isSet(object.sourcePosition)
        ? PositionRef.fromJSON(object.sourcePosition)
        : isSet(object.source_position)
          ? PositionRef.fromJSON(object.source_position)
          : undefined,
      targetExpiry: isSet(object.targetExpiry)
        ? ExpirySpec.fromJSON(object.targetExpiry)
        : isSet(object.target_expiry)
          ? ExpirySpec.fromJSON(object.target_expiry)
          : undefined,
      targetStrike: isSet(object.targetStrike)
        ? StrikeSpec.fromJSON(object.targetStrike)
        : isSet(object.target_strike)
          ? StrikeSpec.fromJSON(object.target_strike)
          : undefined,
      amount: isSet(object.amount) ? Amount.fromJSON(object.amount) : undefined,
      closeStyle: isSet(object.closeStyle)
        ? ExecutionStyle.fromJSON(object.closeStyle)
        : isSet(object.close_style)
          ? ExecutionStyle.fromJSON(object.close_style)
          : undefined,
      openStyle: isSet(object.openStyle)
        ? ExecutionStyle.fromJSON(object.openStyle)
        : isSet(object.open_style)
          ? ExecutionStyle.fromJSON(object.open_style)
          : undefined,
    }
  },

  toJSON(message: Roll): unknown {
    const obj: any = {}
    if (message.sourcePosition !== undefined) {
      obj.sourcePosition = PositionRef.toJSON(message.sourcePosition)
    }
    if (message.targetExpiry !== undefined) {
      obj.targetExpiry = ExpirySpec.toJSON(message.targetExpiry)
    }
    if (message.targetStrike !== undefined) {
      obj.targetStrike = StrikeSpec.toJSON(message.targetStrike)
    }
    if (message.amount !== undefined) {
      obj.amount = Amount.toJSON(message.amount)
    }
    if (message.closeStyle !== undefined) {
      obj.closeStyle = ExecutionStyle.toJSON(message.closeStyle)
    }
    if (message.openStyle !== undefined) {
      obj.openStyle = ExecutionStyle.toJSON(message.openStyle)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Roll>, I>>(base?: I): Roll {
    return Roll.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Roll>, I>>(object: I): Roll {
    const message = createBaseRoll()
    message.sourcePosition =
      object.sourcePosition !== undefined && object.sourcePosition !== null
        ? PositionRef.fromPartial(object.sourcePosition)
        : undefined
    message.targetExpiry =
      object.targetExpiry !== undefined && object.targetExpiry !== null
        ? ExpirySpec.fromPartial(object.targetExpiry)
        : undefined
    message.targetStrike =
      object.targetStrike !== undefined && object.targetStrike !== null
        ? StrikeSpec.fromPartial(object.targetStrike)
        : undefined
    message.amount =
      object.amount !== undefined && object.amount !== null
        ? Amount.fromPartial(object.amount)
        : undefined
    message.closeStyle =
      object.closeStyle !== undefined && object.closeStyle !== null
        ? ExecutionStyle.fromPartial(object.closeStyle)
        : undefined
    message.openStyle =
      object.openStyle !== undefined && object.openStyle !== null
        ? ExecutionStyle.fromPartial(object.openStyle)
        : undefined
    return message
  },
}

function createBaseSingleHedge(): SingleHedge {
  return {
    scope: undefined,
    hedgeInstrument: undefined,
    target: undefined,
    executionStyle: undefined,
  }
}

export const SingleHedge: MessageFns<SingleHedge> = {
  encode(message: SingleHedge, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scope !== undefined) {
      HedgeScope.encode(message.scope, writer.uint32(10).fork()).join()
    }
    if (message.hedgeInstrument !== undefined) {
      InstrumentRef.encode(message.hedgeInstrument, writer.uint32(18).fork()).join()
    }
    if (message.target !== undefined) {
      DeltaTarget.encode(message.target, writer.uint32(26).fork()).join()
    }
    if (message.executionStyle !== undefined) {
      ExecutionStyle.encode(message.executionStyle, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SingleHedge {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSingleHedge()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.scope = HedgeScope.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.hedgeInstrument = InstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.target = DeltaTarget.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.executionStyle = ExecutionStyle.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SingleHedge {
    return {
      scope: isSet(object.scope) ? HedgeScope.fromJSON(object.scope) : undefined,
      hedgeInstrument: isSet(object.hedgeInstrument)
        ? InstrumentRef.fromJSON(object.hedgeInstrument)
        : isSet(object.hedge_instrument)
          ? InstrumentRef.fromJSON(object.hedge_instrument)
          : undefined,
      target: isSet(object.target) ? DeltaTarget.fromJSON(object.target) : undefined,
      executionStyle: isSet(object.executionStyle)
        ? ExecutionStyle.fromJSON(object.executionStyle)
        : isSet(object.execution_style)
          ? ExecutionStyle.fromJSON(object.execution_style)
          : undefined,
    }
  },

  toJSON(message: SingleHedge): unknown {
    const obj: any = {}
    if (message.scope !== undefined) {
      obj.scope = HedgeScope.toJSON(message.scope)
    }
    if (message.hedgeInstrument !== undefined) {
      obj.hedgeInstrument = InstrumentRef.toJSON(message.hedgeInstrument)
    }
    if (message.target !== undefined) {
      obj.target = DeltaTarget.toJSON(message.target)
    }
    if (message.executionStyle !== undefined) {
      obj.executionStyle = ExecutionStyle.toJSON(message.executionStyle)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SingleHedge>, I>>(base?: I): SingleHedge {
    return SingleHedge.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SingleHedge>, I>>(object: I): SingleHedge {
    const message = createBaseSingleHedge()
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? HedgeScope.fromPartial(object.scope)
        : undefined
    message.hedgeInstrument =
      object.hedgeInstrument !== undefined && object.hedgeInstrument !== null
        ? InstrumentRef.fromPartial(object.hedgeInstrument)
        : undefined
    message.target =
      object.target !== undefined && object.target !== null
        ? DeltaTarget.fromPartial(object.target)
        : undefined
    message.executionStyle =
      object.executionStyle !== undefined && object.executionStyle !== null
        ? ExecutionStyle.fromPartial(object.executionStyle)
        : undefined
    return message
  },
}

function createBaseDeltaTarget(): DeltaTarget {
  return { value: '', denomination: 0 }
}

export const DeltaTarget: MessageFns<DeltaTarget> = {
  encode(message: DeltaTarget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== '') {
      writer.uint32(10).string(message.value)
    }
    if (message.denomination !== 0) {
      writer.uint32(16).int32(message.denomination)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeltaTarget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeltaTarget()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.value = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeltaTarget {
    return {
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      denomination: isSet(object.denomination) ? deltaDenominationFromJSON(object.denomination) : 0,
    }
  },

  toJSON(message: DeltaTarget): unknown {
    const obj: any = {}
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.denomination !== 0) {
      obj.denomination = deltaDenominationToJSON(message.denomination)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeltaTarget>, I>>(base?: I): DeltaTarget {
    return DeltaTarget.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeltaTarget>, I>>(object: I): DeltaTarget {
    const message = createBaseDeltaTarget()
    message.value = object.value ?? ''
    message.denomination = object.denomination ?? 0
    return message
  },
}

function createBaseHedgeSubscription(): HedgeSubscription {
  return {
    scope: undefined,
    deltaBands: undefined,
    positiveGammaTreatment: undefined,
    hedgeInstrument: undefined,
    replaceOverlapping: undefined,
    deltaStream: undefined,
    interval: undefined,
  }
}

export const HedgeSubscription: MessageFns<HedgeSubscription> = {
  encode(message: HedgeSubscription, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scope !== undefined) {
      HedgeScope.encode(message.scope, writer.uint32(10).fork()).join()
    }
    if (message.deltaBands !== undefined) {
      HedgeDeltaBands.encode(message.deltaBands, writer.uint32(18).fork()).join()
    }
    if (message.positiveGammaTreatment !== undefined) {
      writer.uint32(24).bool(message.positiveGammaTreatment)
    }
    if (message.hedgeInstrument !== undefined) {
      InstrumentRef.encode(message.hedgeInstrument, writer.uint32(34).fork()).join()
    }
    if (message.replaceOverlapping !== undefined) {
      writer.uint32(56).bool(message.replaceOverlapping)
    }
    if (message.deltaStream !== undefined) {
      DeltaStreamHedgeMode.encode(message.deltaStream, writer.uint32(42).fork()).join()
    }
    if (message.interval !== undefined) {
      IntervalHedgeMode.encode(message.interval, writer.uint32(50).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HedgeSubscription {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHedgeSubscription()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.scope = HedgeScope.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.deltaBands = HedgeDeltaBands.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.positiveGammaTreatment = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.hedgeInstrument = InstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.replaceOverlapping = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.deltaStream = DeltaStreamHedgeMode.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.interval = IntervalHedgeMode.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HedgeSubscription {
    return {
      scope: isSet(object.scope) ? HedgeScope.fromJSON(object.scope) : undefined,
      deltaBands: isSet(object.deltaBands)
        ? HedgeDeltaBands.fromJSON(object.deltaBands)
        : isSet(object.delta_bands)
          ? HedgeDeltaBands.fromJSON(object.delta_bands)
          : undefined,
      positiveGammaTreatment: isSet(object.positiveGammaTreatment)
        ? globalThis.Boolean(object.positiveGammaTreatment)
        : isSet(object.positive_gamma_treatment)
          ? globalThis.Boolean(object.positive_gamma_treatment)
          : undefined,
      hedgeInstrument: isSet(object.hedgeInstrument)
        ? InstrumentRef.fromJSON(object.hedgeInstrument)
        : isSet(object.hedge_instrument)
          ? InstrumentRef.fromJSON(object.hedge_instrument)
          : undefined,
      replaceOverlapping: isSet(object.replaceOverlapping)
        ? globalThis.Boolean(object.replaceOverlapping)
        : isSet(object.replace_overlapping)
          ? globalThis.Boolean(object.replace_overlapping)
          : undefined,
      deltaStream: isSet(object.deltaStream)
        ? DeltaStreamHedgeMode.fromJSON(object.deltaStream)
        : isSet(object.delta_stream)
          ? DeltaStreamHedgeMode.fromJSON(object.delta_stream)
          : undefined,
      interval: isSet(object.interval) ? IntervalHedgeMode.fromJSON(object.interval) : undefined,
    }
  },

  toJSON(message: HedgeSubscription): unknown {
    const obj: any = {}
    if (message.scope !== undefined) {
      obj.scope = HedgeScope.toJSON(message.scope)
    }
    if (message.deltaBands !== undefined) {
      obj.deltaBands = HedgeDeltaBands.toJSON(message.deltaBands)
    }
    if (message.positiveGammaTreatment !== undefined) {
      obj.positiveGammaTreatment = message.positiveGammaTreatment
    }
    if (message.hedgeInstrument !== undefined) {
      obj.hedgeInstrument = InstrumentRef.toJSON(message.hedgeInstrument)
    }
    if (message.replaceOverlapping !== undefined) {
      obj.replaceOverlapping = message.replaceOverlapping
    }
    if (message.deltaStream !== undefined) {
      obj.deltaStream = DeltaStreamHedgeMode.toJSON(message.deltaStream)
    }
    if (message.interval !== undefined) {
      obj.interval = IntervalHedgeMode.toJSON(message.interval)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HedgeSubscription>, I>>(base?: I): HedgeSubscription {
    return HedgeSubscription.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HedgeSubscription>, I>>(object: I): HedgeSubscription {
    const message = createBaseHedgeSubscription()
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? HedgeScope.fromPartial(object.scope)
        : undefined
    message.deltaBands =
      object.deltaBands !== undefined && object.deltaBands !== null
        ? HedgeDeltaBands.fromPartial(object.deltaBands)
        : undefined
    message.positiveGammaTreatment = object.positiveGammaTreatment ?? undefined
    message.hedgeInstrument =
      object.hedgeInstrument !== undefined && object.hedgeInstrument !== null
        ? InstrumentRef.fromPartial(object.hedgeInstrument)
        : undefined
    message.replaceOverlapping = object.replaceOverlapping ?? undefined
    message.deltaStream =
      object.deltaStream !== undefined && object.deltaStream !== null
        ? DeltaStreamHedgeMode.fromPartial(object.deltaStream)
        : undefined
    message.interval =
      object.interval !== undefined && object.interval !== null
        ? IntervalHedgeMode.fromPartial(object.interval)
        : undefined
    return message
  },
}

function createBaseDeltaStreamHedgeMode(): DeltaStreamHedgeMode {
  return { minReevalMs: undefined }
}

export const DeltaStreamHedgeMode: MessageFns<DeltaStreamHedgeMode> = {
  encode(message: DeltaStreamHedgeMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minReevalMs !== undefined) {
      writer.uint32(8).int64(message.minReevalMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeltaStreamHedgeMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeltaStreamHedgeMode()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.minReevalMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeltaStreamHedgeMode {
    return {
      minReevalMs: isSet(object.minReevalMs)
        ? globalThis.String(object.minReevalMs)
        : isSet(object.min_reeval_ms)
          ? globalThis.String(object.min_reeval_ms)
          : undefined,
    }
  },

  toJSON(message: DeltaStreamHedgeMode): unknown {
    const obj: any = {}
    if (message.minReevalMs !== undefined) {
      obj.minReevalMs = message.minReevalMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeltaStreamHedgeMode>, I>>(base?: I): DeltaStreamHedgeMode {
    return DeltaStreamHedgeMode.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeltaStreamHedgeMode>, I>>(
    object: I
  ): DeltaStreamHedgeMode {
    const message = createBaseDeltaStreamHedgeMode()
    message.minReevalMs = object.minReevalMs ?? undefined
    return message
  },
}

function createBaseIntervalHedgeMode(): IntervalHedgeMode {
  return { intervalSeconds: '0' }
}

export const IntervalHedgeMode: MessageFns<IntervalHedgeMode> = {
  encode(message: IntervalHedgeMode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervalSeconds !== '0') {
      writer.uint32(8).int64(message.intervalSeconds)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntervalHedgeMode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseIntervalHedgeMode()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.intervalSeconds = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): IntervalHedgeMode {
    return {
      intervalSeconds: isSet(object.intervalSeconds)
        ? globalThis.String(object.intervalSeconds)
        : isSet(object.interval_seconds)
          ? globalThis.String(object.interval_seconds)
          : '0',
    }
  },

  toJSON(message: IntervalHedgeMode): unknown {
    const obj: any = {}
    if (message.intervalSeconds !== '0') {
      obj.intervalSeconds = message.intervalSeconds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<IntervalHedgeMode>, I>>(base?: I): IntervalHedgeMode {
    return IntervalHedgeMode.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<IntervalHedgeMode>, I>>(object: I): IntervalHedgeMode {
    const message = createBaseIntervalHedgeMode()
    message.intervalSeconds = object.intervalSeconds ?? '0'
    return message
  },
}

function createBaseHedgeScope(): HedgeScope {
  return { portfolio: undefined, positionGroup: undefined }
}

export const HedgeScope: MessageFns<HedgeScope> = {
  encode(message: HedgeScope, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.portfolio !== undefined) {
      PortfolioScope.encode(message.portfolio, writer.uint32(10).fork()).join()
    }
    if (message.positionGroup !== undefined) {
      PositionGroupScope.encode(message.positionGroup, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HedgeScope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHedgeScope()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.portfolio = PortfolioScope.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.positionGroup = PositionGroupScope.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HedgeScope {
    return {
      portfolio: isSet(object.portfolio) ? PortfolioScope.fromJSON(object.portfolio) : undefined,
      positionGroup: isSet(object.positionGroup)
        ? PositionGroupScope.fromJSON(object.positionGroup)
        : isSet(object.position_group)
          ? PositionGroupScope.fromJSON(object.position_group)
          : undefined,
    }
  },

  toJSON(message: HedgeScope): unknown {
    const obj: any = {}
    if (message.portfolio !== undefined) {
      obj.portfolio = PortfolioScope.toJSON(message.portfolio)
    }
    if (message.positionGroup !== undefined) {
      obj.positionGroup = PositionGroupScope.toJSON(message.positionGroup)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HedgeScope>, I>>(base?: I): HedgeScope {
    return HedgeScope.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HedgeScope>, I>>(object: I): HedgeScope {
    const message = createBaseHedgeScope()
    message.portfolio =
      object.portfolio !== undefined && object.portfolio !== null
        ? PortfolioScope.fromPartial(object.portfolio)
        : undefined
    message.positionGroup =
      object.positionGroup !== undefined && object.positionGroup !== null
        ? PositionGroupScope.fromPartial(object.positionGroup)
        : undefined
    return message
  },
}

function createBasePortfolioScope(): PortfolioScope {
  return { underlying: undefined }
}

export const PortfolioScope: MessageFns<PortfolioScope> = {
  encode(message: PortfolioScope, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.underlying !== undefined) {
      AssetRef.encode(message.underlying, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortfolioScope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePortfolioScope()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.underlying = AssetRef.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PortfolioScope {
    return {
      underlying: isSet(object.underlying) ? AssetRef.fromJSON(object.underlying) : undefined,
    }
  },

  toJSON(message: PortfolioScope): unknown {
    const obj: any = {}
    if (message.underlying !== undefined) {
      obj.underlying = AssetRef.toJSON(message.underlying)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PortfolioScope>, I>>(base?: I): PortfolioScope {
    return PortfolioScope.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PortfolioScope>, I>>(object: I): PortfolioScope {
    const message = createBasePortfolioScope()
    message.underlying =
      object.underlying !== undefined && object.underlying !== null
        ? AssetRef.fromPartial(object.underlying)
        : undefined
    return message
  },
}

function createBasePositionGroupScope(): PositionGroupScope {
  return { positions: [], label: undefined }
}

export const PositionGroupScope: MessageFns<PositionGroupScope> = {
  encode(message: PositionGroupScope, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.positions) {
      SingularPositionRef.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.label !== undefined) {
      writer.uint32(18).string(message.label)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionGroupScope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionGroupScope()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.positions.push(SingularPositionRef.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.label = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionGroupScope {
    return {
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => SingularPositionRef.fromJSON(e))
        : [],
      label: isSet(object.label) ? globalThis.String(object.label) : undefined,
    }
  },

  toJSON(message: PositionGroupScope): unknown {
    const obj: any = {}
    if (message.positions?.length) {
      obj.positions = message.positions.map((e) => SingularPositionRef.toJSON(e))
    }
    if (message.label !== undefined) {
      obj.label = message.label
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionGroupScope>, I>>(base?: I): PositionGroupScope {
    return PositionGroupScope.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionGroupScope>, I>>(object: I): PositionGroupScope {
    const message = createBasePositionGroupScope()
    message.positions = object.positions?.map((e) => SingularPositionRef.fromPartial(e)) || []
    message.label = object.label ?? undefined
    return message
  },
}

function createBaseSingularPositionRef(): SingularPositionRef {
  return { instrument: undefined }
}

export const SingularPositionRef: MessageFns<SingularPositionRef> = {
  encode(message: SingularPositionRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instrument !== undefined) {
      InstrumentRef.encode(message.instrument, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SingularPositionRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSingularPositionRef()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break
          }

          message.instrument = InstrumentRef.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SingularPositionRef {
    return {
      instrument: isSet(object.instrument) ? InstrumentRef.fromJSON(object.instrument) : undefined,
    }
  },

  toJSON(message: SingularPositionRef): unknown {
    const obj: any = {}
    if (message.instrument !== undefined) {
      obj.instrument = InstrumentRef.toJSON(message.instrument)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SingularPositionRef>, I>>(base?: I): SingularPositionRef {
    return SingularPositionRef.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SingularPositionRef>, I>>(
    object: I
  ): SingularPositionRef {
    const message = createBaseSingularPositionRef()
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? InstrumentRef.fromPartial(object.instrument)
        : undefined
    return message
  },
}

function createBaseHedgeDeltaBands(): HedgeDeltaBands {
  return {
    acceptable: undefined,
    maxLowPriority: undefined,
    maxMediumPriority: undefined,
    maxHighPriority: undefined,
    minLowPriority: undefined,
    minMediumPriority: undefined,
    minHighPriority: undefined,
    denomination: 0,
  }
}

export const HedgeDeltaBands: MessageFns<HedgeDeltaBands> = {
  encode(message: HedgeDeltaBands, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.acceptable !== undefined) {
      DeltaBand.encode(message.acceptable, writer.uint32(10).fork()).join()
    }
    if (message.maxLowPriority !== undefined) {
      PriorityDeltaBand.encode(message.maxLowPriority, writer.uint32(18).fork()).join()
    }
    if (message.maxMediumPriority !== undefined) {
      PriorityDeltaBand.encode(message.maxMediumPriority, writer.uint32(26).fork()).join()
    }
    if (message.maxHighPriority !== undefined) {
      PriorityDeltaBand.encode(message.maxHighPriority, writer.uint32(34).fork()).join()
    }
    if (message.minLowPriority !== undefined) {
      PriorityDeltaBand.encode(message.minLowPriority, writer.uint32(42).fork()).join()
    }
    if (message.minMediumPriority !== undefined) {
      PriorityDeltaBand.encode(message.minMediumPriority, writer.uint32(50).fork()).join()
    }
    if (message.minHighPriority !== undefined) {
      PriorityDeltaBand.encode(message.minHighPriority, writer.uint32(58).fork()).join()
    }
    if (message.denomination !== 0) {
      writer.uint32(64).int32(message.denomination)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HedgeDeltaBands {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHedgeDeltaBands()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.acceptable = DeltaBand.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.maxLowPriority = PriorityDeltaBand.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.maxMediumPriority = PriorityDeltaBand.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.maxHighPriority = PriorityDeltaBand.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.minLowPriority = PriorityDeltaBand.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.minMediumPriority = PriorityDeltaBand.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.minHighPriority = PriorityDeltaBand.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HedgeDeltaBands {
    return {
      acceptable: isSet(object.acceptable) ? DeltaBand.fromJSON(object.acceptable) : undefined,
      maxLowPriority: isSet(object.maxLowPriority)
        ? PriorityDeltaBand.fromJSON(object.maxLowPriority)
        : isSet(object.max_low_priority)
          ? PriorityDeltaBand.fromJSON(object.max_low_priority)
          : undefined,
      maxMediumPriority: isSet(object.maxMediumPriority)
        ? PriorityDeltaBand.fromJSON(object.maxMediumPriority)
        : isSet(object.max_medium_priority)
          ? PriorityDeltaBand.fromJSON(object.max_medium_priority)
          : undefined,
      maxHighPriority: isSet(object.maxHighPriority)
        ? PriorityDeltaBand.fromJSON(object.maxHighPriority)
        : isSet(object.max_high_priority)
          ? PriorityDeltaBand.fromJSON(object.max_high_priority)
          : undefined,
      minLowPriority: isSet(object.minLowPriority)
        ? PriorityDeltaBand.fromJSON(object.minLowPriority)
        : isSet(object.min_low_priority)
          ? PriorityDeltaBand.fromJSON(object.min_low_priority)
          : undefined,
      minMediumPriority: isSet(object.minMediumPriority)
        ? PriorityDeltaBand.fromJSON(object.minMediumPriority)
        : isSet(object.min_medium_priority)
          ? PriorityDeltaBand.fromJSON(object.min_medium_priority)
          : undefined,
      minHighPriority: isSet(object.minHighPriority)
        ? PriorityDeltaBand.fromJSON(object.minHighPriority)
        : isSet(object.min_high_priority)
          ? PriorityDeltaBand.fromJSON(object.min_high_priority)
          : undefined,
      denomination: isSet(object.denomination) ? deltaDenominationFromJSON(object.denomination) : 0,
    }
  },

  toJSON(message: HedgeDeltaBands): unknown {
    const obj: any = {}
    if (message.acceptable !== undefined) {
      obj.acceptable = DeltaBand.toJSON(message.acceptable)
    }
    if (message.maxLowPriority !== undefined) {
      obj.maxLowPriority = PriorityDeltaBand.toJSON(message.maxLowPriority)
    }
    if (message.maxMediumPriority !== undefined) {
      obj.maxMediumPriority = PriorityDeltaBand.toJSON(message.maxMediumPriority)
    }
    if (message.maxHighPriority !== undefined) {
      obj.maxHighPriority = PriorityDeltaBand.toJSON(message.maxHighPriority)
    }
    if (message.minLowPriority !== undefined) {
      obj.minLowPriority = PriorityDeltaBand.toJSON(message.minLowPriority)
    }
    if (message.minMediumPriority !== undefined) {
      obj.minMediumPriority = PriorityDeltaBand.toJSON(message.minMediumPriority)
    }
    if (message.minHighPriority !== undefined) {
      obj.minHighPriority = PriorityDeltaBand.toJSON(message.minHighPriority)
    }
    if (message.denomination !== 0) {
      obj.denomination = deltaDenominationToJSON(message.denomination)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HedgeDeltaBands>, I>>(base?: I): HedgeDeltaBands {
    return HedgeDeltaBands.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HedgeDeltaBands>, I>>(object: I): HedgeDeltaBands {
    const message = createBaseHedgeDeltaBands()
    message.acceptable =
      object.acceptable !== undefined && object.acceptable !== null
        ? DeltaBand.fromPartial(object.acceptable)
        : undefined
    message.maxLowPriority =
      object.maxLowPriority !== undefined && object.maxLowPriority !== null
        ? PriorityDeltaBand.fromPartial(object.maxLowPriority)
        : undefined
    message.maxMediumPriority =
      object.maxMediumPriority !== undefined && object.maxMediumPriority !== null
        ? PriorityDeltaBand.fromPartial(object.maxMediumPriority)
        : undefined
    message.maxHighPriority =
      object.maxHighPriority !== undefined && object.maxHighPriority !== null
        ? PriorityDeltaBand.fromPartial(object.maxHighPriority)
        : undefined
    message.minLowPriority =
      object.minLowPriority !== undefined && object.minLowPriority !== null
        ? PriorityDeltaBand.fromPartial(object.minLowPriority)
        : undefined
    message.minMediumPriority =
      object.minMediumPriority !== undefined && object.minMediumPriority !== null
        ? PriorityDeltaBand.fromPartial(object.minMediumPriority)
        : undefined
    message.minHighPriority =
      object.minHighPriority !== undefined && object.minHighPriority !== null
        ? PriorityDeltaBand.fromPartial(object.minHighPriority)
        : undefined
    message.denomination = object.denomination ?? 0
    return message
  },
}

function createBaseDeltaBand(): DeltaBand {
  return { from: '', to: '', target: '' }
}

export const DeltaBand: MessageFns<DeltaBand> = {
  encode(message: DeltaBand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.from !== '') {
      writer.uint32(10).string(message.from)
    }
    if (message.to !== '') {
      writer.uint32(18).string(message.to)
    }
    if (message.target !== '') {
      writer.uint32(26).string(message.target)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeltaBand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeltaBand()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.from = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.to = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.target = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeltaBand {
    return {
      from: isSet(object.from) ? globalThis.String(object.from) : '',
      to: isSet(object.to) ? globalThis.String(object.to) : '',
      target: isSet(object.target) ? globalThis.String(object.target) : '',
    }
  },

  toJSON(message: DeltaBand): unknown {
    const obj: any = {}
    if (message.from !== '') {
      obj.from = message.from
    }
    if (message.to !== '') {
      obj.to = message.to
    }
    if (message.target !== '') {
      obj.target = message.target
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeltaBand>, I>>(base?: I): DeltaBand {
    return DeltaBand.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeltaBand>, I>>(object: I): DeltaBand {
    const message = createBaseDeltaBand()
    message.from = object.from ?? ''
    message.to = object.to ?? ''
    message.target = object.target ?? ''
    return message
  },
}

function createBasePriorityDeltaBand(): PriorityDeltaBand {
  return { from: '', to: '', target: '', hedgingMechanism: undefined }
}

export const PriorityDeltaBand: MessageFns<PriorityDeltaBand> = {
  encode(message: PriorityDeltaBand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.from !== '') {
      writer.uint32(10).string(message.from)
    }
    if (message.to !== '') {
      writer.uint32(18).string(message.to)
    }
    if (message.target !== '') {
      writer.uint32(26).string(message.target)
    }
    if (message.hedgingMechanism !== undefined) {
      ExecutionStyle.encode(message.hedgingMechanism, writer.uint32(34).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PriorityDeltaBand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePriorityDeltaBand()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.from = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.to = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.target = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.hedgingMechanism = ExecutionStyle.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PriorityDeltaBand {
    return {
      from: isSet(object.from) ? globalThis.String(object.from) : '',
      to: isSet(object.to) ? globalThis.String(object.to) : '',
      target: isSet(object.target) ? globalThis.String(object.target) : '',
      hedgingMechanism: isSet(object.hedgingMechanism)
        ? ExecutionStyle.fromJSON(object.hedgingMechanism)
        : isSet(object.hedging_mechanism)
          ? ExecutionStyle.fromJSON(object.hedging_mechanism)
          : undefined,
    }
  },

  toJSON(message: PriorityDeltaBand): unknown {
    const obj: any = {}
    if (message.from !== '') {
      obj.from = message.from
    }
    if (message.to !== '') {
      obj.to = message.to
    }
    if (message.target !== '') {
      obj.target = message.target
    }
    if (message.hedgingMechanism !== undefined) {
      obj.hedgingMechanism = ExecutionStyle.toJSON(message.hedgingMechanism)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PriorityDeltaBand>, I>>(base?: I): PriorityDeltaBand {
    return PriorityDeltaBand.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PriorityDeltaBand>, I>>(object: I): PriorityDeltaBand {
    const message = createBasePriorityDeltaBand()
    message.from = object.from ?? ''
    message.to = object.to ?? ''
    message.target = object.target ?? ''
    message.hedgingMechanism =
      object.hedgingMechanism !== undefined && object.hedgingMechanism !== null
        ? ExecutionStyle.fromPartial(object.hedgingMechanism)
        : undefined
    return message
  },
}

function createBaseUpdateOrder(): UpdateOrder {
  return {
    orderId: '',
    quantity: undefined,
    price: undefined,
    timeInForce: undefined,
    postOnly: undefined,
    reduceOnly: undefined,
  }
}

export const UpdateOrder: MessageFns<UpdateOrder> = {
  encode(message: UpdateOrder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orderId !== '') {
      writer.uint32(10).string(message.orderId)
    }
    if (message.quantity !== undefined) {
      UpdateOrderQuantity.encode(message.quantity, writer.uint32(18).fork()).join()
    }
    if (message.price !== undefined) {
      PriceSpec.encode(message.price, writer.uint32(26).fork()).join()
    }
    if (message.timeInForce !== undefined) {
      writer.uint32(32).int32(message.timeInForce)
    }
    if (message.postOnly !== undefined) {
      writer.uint32(40).bool(message.postOnly)
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(48).bool(message.reduceOnly)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdateOrder()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orderId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quantity = UpdateOrderQuantity.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.price = PriceSpec.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.timeInForce = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.postOnly = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdateOrder {
    return {
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
      quantity: isSet(object.quantity) ? UpdateOrderQuantity.fromJSON(object.quantity) : undefined,
      price: isSet(object.price) ? PriceSpec.fromJSON(object.price) : undefined,
      timeInForce: isSet(object.timeInForce)
        ? timeInForceFromJSON(object.timeInForce)
        : isSet(object.time_in_force)
          ? timeInForceFromJSON(object.time_in_force)
          : undefined,
      postOnly: isSet(object.postOnly)
        ? globalThis.Boolean(object.postOnly)
        : isSet(object.post_only)
          ? globalThis.Boolean(object.post_only)
          : undefined,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
    }
  },

  toJSON(message: UpdateOrder): unknown {
    const obj: any = {}
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    if (message.quantity !== undefined) {
      obj.quantity = UpdateOrderQuantity.toJSON(message.quantity)
    }
    if (message.price !== undefined) {
      obj.price = PriceSpec.toJSON(message.price)
    }
    if (message.timeInForce !== undefined) {
      obj.timeInForce = timeInForceToJSON(message.timeInForce)
    }
    if (message.postOnly !== undefined) {
      obj.postOnly = message.postOnly
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdateOrder>, I>>(base?: I): UpdateOrder {
    return UpdateOrder.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdateOrder>, I>>(object: I): UpdateOrder {
    const message = createBaseUpdateOrder()
    message.orderId = object.orderId ?? ''
    message.quantity =
      object.quantity !== undefined && object.quantity !== null
        ? UpdateOrderQuantity.fromPartial(object.quantity)
        : undefined
    message.price =
      object.price !== undefined && object.price !== null
        ? PriceSpec.fromPartial(object.price)
        : undefined
    message.timeInForce = object.timeInForce ?? undefined
    message.postOnly = object.postOnly ?? undefined
    message.reduceOnly = object.reduceOnly ?? undefined
    return message
  },
}

function createBaseUpdateOrderQuantity(): UpdateOrderQuantity {
  return { absolute: undefined, delta: undefined }
}

export const UpdateOrderQuantity: MessageFns<UpdateOrderQuantity> = {
  encode(message: UpdateOrderQuantity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.absolute !== undefined) {
      Amount.encode(message.absolute, writer.uint32(10).fork()).join()
    }
    if (message.delta !== undefined) {
      QuantityDelta.encode(message.delta, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrderQuantity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdateOrderQuantity()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.absolute = Amount.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.delta = QuantityDelta.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdateOrderQuantity {
    return {
      absolute: isSet(object.absolute) ? Amount.fromJSON(object.absolute) : undefined,
      delta: isSet(object.delta) ? QuantityDelta.fromJSON(object.delta) : undefined,
    }
  },

  toJSON(message: UpdateOrderQuantity): unknown {
    const obj: any = {}
    if (message.absolute !== undefined) {
      obj.absolute = Amount.toJSON(message.absolute)
    }
    if (message.delta !== undefined) {
      obj.delta = QuantityDelta.toJSON(message.delta)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdateOrderQuantity>, I>>(base?: I): UpdateOrderQuantity {
    return UpdateOrderQuantity.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdateOrderQuantity>, I>>(
    object: I
  ): UpdateOrderQuantity {
    const message = createBaseUpdateOrderQuantity()
    message.absolute =
      object.absolute !== undefined && object.absolute !== null
        ? Amount.fromPartial(object.absolute)
        : undefined
    message.delta =
      object.delta !== undefined && object.delta !== null
        ? QuantityDelta.fromPartial(object.delta)
        : undefined
    return message
  },
}

function createBaseQuantityDelta(): QuantityDelta {
  return { direction: 0, amount: undefined }
}

export const QuantityDelta: MessageFns<QuantityDelta> = {
  encode(message: QuantityDelta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.direction !== 0) {
      writer.uint32(8).int32(message.direction)
    }
    if (message.amount !== undefined) {
      Amount.encode(message.amount, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QuantityDelta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseQuantityDelta()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.direction = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.amount = Amount.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): QuantityDelta {
    return {
      direction: isSet(object.direction) ? quantityDeltaDirectionFromJSON(object.direction) : 0,
      amount: isSet(object.amount) ? Amount.fromJSON(object.amount) : undefined,
    }
  },

  toJSON(message: QuantityDelta): unknown {
    const obj: any = {}
    if (message.direction !== 0) {
      obj.direction = quantityDeltaDirectionToJSON(message.direction)
    }
    if (message.amount !== undefined) {
      obj.amount = Amount.toJSON(message.amount)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<QuantityDelta>, I>>(base?: I): QuantityDelta {
    return QuantityDelta.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<QuantityDelta>, I>>(object: I): QuantityDelta {
    const message = createBaseQuantityDelta()
    message.direction = object.direction ?? 0
    message.amount =
      object.amount !== undefined && object.amount !== null
        ? Amount.fromPartial(object.amount)
        : undefined
    return message
  },
}

function createBaseCancelOrder(): CancelOrder {
  return { orderId: '', reason: undefined }
}

export const CancelOrder: MessageFns<CancelOrder> = {
  encode(message: CancelOrder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orderId !== '') {
      writer.uint32(10).string(message.orderId)
    }
    if (message.reason !== undefined) {
      writer.uint32(18).string(message.reason)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelOrder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelOrder()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orderId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.reason = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelOrder {
    return {
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
      reason: isSet(object.reason) ? globalThis.String(object.reason) : undefined,
    }
  },

  toJSON(message: CancelOrder): unknown {
    const obj: any = {}
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    if (message.reason !== undefined) {
      obj.reason = message.reason
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelOrder>, I>>(base?: I): CancelOrder {
    return CancelOrder.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelOrder>, I>>(object: I): CancelOrder {
    const message = createBaseCancelOrder()
    message.orderId = object.orderId ?? ''
    message.reason = object.reason ?? undefined
    return message
  },
}

function createBaseCancelAlgo(): CancelAlgo {
  return { algoId: '', reason: undefined }
}

export const CancelAlgo: MessageFns<CancelAlgo> = {
  encode(message: CancelAlgo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.algoId !== '') {
      writer.uint32(10).string(message.algoId)
    }
    if (message.reason !== undefined) {
      writer.uint32(18).string(message.reason)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelAlgo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelAlgo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.algoId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.reason = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelAlgo {
    return {
      algoId: isSet(object.algoId)
        ? globalThis.String(object.algoId)
        : isSet(object.algo_id)
          ? globalThis.String(object.algo_id)
          : '',
      reason: isSet(object.reason) ? globalThis.String(object.reason) : undefined,
    }
  },

  toJSON(message: CancelAlgo): unknown {
    const obj: any = {}
    if (message.algoId !== '') {
      obj.algoId = message.algoId
    }
    if (message.reason !== undefined) {
      obj.reason = message.reason
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelAlgo>, I>>(base?: I): CancelAlgo {
    return CancelAlgo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelAlgo>, I>>(object: I): CancelAlgo {
    const message = createBaseCancelAlgo()
    message.algoId = object.algoId ?? ''
    message.reason = object.reason ?? undefined
    return message
  },
}

function createBaseCancelAllOrders(): CancelAllOrders {
  return { scope: undefined, reason: undefined }
}

export const CancelAllOrders: MessageFns<CancelAllOrders> = {
  encode(message: CancelAllOrders, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scope !== undefined) {
      InstrumentRef.encode(message.scope, writer.uint32(10).fork()).join()
    }
    if (message.reason !== undefined) {
      writer.uint32(18).string(message.reason)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelAllOrders {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelAllOrders()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.scope = InstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.reason = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelAllOrders {
    return {
      scope: isSet(object.scope) ? InstrumentRef.fromJSON(object.scope) : undefined,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : undefined,
    }
  },

  toJSON(message: CancelAllOrders): unknown {
    const obj: any = {}
    if (message.scope !== undefined) {
      obj.scope = InstrumentRef.toJSON(message.scope)
    }
    if (message.reason !== undefined) {
      obj.reason = message.reason
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelAllOrders>, I>>(base?: I): CancelAllOrders {
    return CancelAllOrders.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelAllOrders>, I>>(object: I): CancelAllOrders {
    const message = createBaseCancelAllOrders()
    message.scope =
      object.scope !== undefined && object.scope !== null
        ? InstrumentRef.fromPartial(object.scope)
        : undefined
    message.reason = object.reason ?? undefined
    return message
  },
}

function createBaseExecutionStyle(): ExecutionStyle {
  return {
    kind: 0,
    limitPrice: undefined,
    timeInForce: undefined,
    postOnly: undefined,
    twapDurationSeconds: undefined,
    twapLimitPrice: undefined,
    startingPrice: undefined,
    scaleRange: undefined,
    scaleOrderCount: undefined,
    scaleSizeRatio: undefined,
  }
}

export const ExecutionStyle: MessageFns<ExecutionStyle> = {
  encode(message: ExecutionStyle, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind)
    }
    if (message.limitPrice !== undefined) {
      PriceSpec.encode(message.limitPrice, writer.uint32(18).fork()).join()
    }
    if (message.timeInForce !== undefined) {
      writer.uint32(24).int32(message.timeInForce)
    }
    if (message.postOnly !== undefined) {
      writer.uint32(32).bool(message.postOnly)
    }
    if (message.twapDurationSeconds !== undefined) {
      writer.uint32(40).int64(message.twapDurationSeconds)
    }
    if (message.twapLimitPrice !== undefined) {
      PriceSpec.encode(message.twapLimitPrice, writer.uint32(50).fork()).join()
    }
    if (message.startingPrice !== undefined) {
      PriceSpec.encode(message.startingPrice, writer.uint32(58).fork()).join()
    }
    if (message.scaleRange !== undefined) {
      PriceBand.encode(message.scaleRange, writer.uint32(66).fork()).join()
    }
    if (message.scaleOrderCount !== undefined) {
      writer.uint32(72).uint32(message.scaleOrderCount)
    }
    if (message.scaleSizeRatio !== undefined) {
      writer.uint32(82).string(message.scaleSizeRatio)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionStyle {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutionStyle()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.limitPrice = PriceSpec.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.timeInForce = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.postOnly = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.twapDurationSeconds = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.twapLimitPrice = PriceSpec.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.startingPrice = PriceSpec.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.scaleRange = PriceBand.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.scaleOrderCount = reader.uint32()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.scaleSizeRatio = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutionStyle {
    return {
      kind: isSet(object.kind) ? executionStyleKindFromJSON(object.kind) : 0,
      limitPrice: isSet(object.limitPrice)
        ? PriceSpec.fromJSON(object.limitPrice)
        : isSet(object.limit_price)
          ? PriceSpec.fromJSON(object.limit_price)
          : undefined,
      timeInForce: isSet(object.timeInForce)
        ? timeInForceFromJSON(object.timeInForce)
        : isSet(object.time_in_force)
          ? timeInForceFromJSON(object.time_in_force)
          : undefined,
      postOnly: isSet(object.postOnly)
        ? globalThis.Boolean(object.postOnly)
        : isSet(object.post_only)
          ? globalThis.Boolean(object.post_only)
          : undefined,
      twapDurationSeconds: isSet(object.twapDurationSeconds)
        ? globalThis.String(object.twapDurationSeconds)
        : isSet(object.twap_duration_seconds)
          ? globalThis.String(object.twap_duration_seconds)
          : undefined,
      twapLimitPrice: isSet(object.twapLimitPrice)
        ? PriceSpec.fromJSON(object.twapLimitPrice)
        : isSet(object.twap_limit_price)
          ? PriceSpec.fromJSON(object.twap_limit_price)
          : undefined,
      startingPrice: isSet(object.startingPrice)
        ? PriceSpec.fromJSON(object.startingPrice)
        : isSet(object.starting_price)
          ? PriceSpec.fromJSON(object.starting_price)
          : undefined,
      scaleRange: isSet(object.scaleRange)
        ? PriceBand.fromJSON(object.scaleRange)
        : isSet(object.scale_range)
          ? PriceBand.fromJSON(object.scale_range)
          : undefined,
      scaleOrderCount: isSet(object.scaleOrderCount)
        ? globalThis.Number(object.scaleOrderCount)
        : isSet(object.scale_order_count)
          ? globalThis.Number(object.scale_order_count)
          : undefined,
      scaleSizeRatio: isSet(object.scaleSizeRatio)
        ? globalThis.String(object.scaleSizeRatio)
        : isSet(object.scale_size_ratio)
          ? globalThis.String(object.scale_size_ratio)
          : undefined,
    }
  },

  toJSON(message: ExecutionStyle): unknown {
    const obj: any = {}
    if (message.kind !== 0) {
      obj.kind = executionStyleKindToJSON(message.kind)
    }
    if (message.limitPrice !== undefined) {
      obj.limitPrice = PriceSpec.toJSON(message.limitPrice)
    }
    if (message.timeInForce !== undefined) {
      obj.timeInForce = timeInForceToJSON(message.timeInForce)
    }
    if (message.postOnly !== undefined) {
      obj.postOnly = message.postOnly
    }
    if (message.twapDurationSeconds !== undefined) {
      obj.twapDurationSeconds = message.twapDurationSeconds
    }
    if (message.twapLimitPrice !== undefined) {
      obj.twapLimitPrice = PriceSpec.toJSON(message.twapLimitPrice)
    }
    if (message.startingPrice !== undefined) {
      obj.startingPrice = PriceSpec.toJSON(message.startingPrice)
    }
    if (message.scaleRange !== undefined) {
      obj.scaleRange = PriceBand.toJSON(message.scaleRange)
    }
    if (message.scaleOrderCount !== undefined) {
      obj.scaleOrderCount = Math.round(message.scaleOrderCount)
    }
    if (message.scaleSizeRatio !== undefined) {
      obj.scaleSizeRatio = message.scaleSizeRatio
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutionStyle>, I>>(base?: I): ExecutionStyle {
    return ExecutionStyle.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionStyle>, I>>(object: I): ExecutionStyle {
    const message = createBaseExecutionStyle()
    message.kind = object.kind ?? 0
    message.limitPrice =
      object.limitPrice !== undefined && object.limitPrice !== null
        ? PriceSpec.fromPartial(object.limitPrice)
        : undefined
    message.timeInForce = object.timeInForce ?? undefined
    message.postOnly = object.postOnly ?? undefined
    message.twapDurationSeconds = object.twapDurationSeconds ?? undefined
    message.twapLimitPrice =
      object.twapLimitPrice !== undefined && object.twapLimitPrice !== null
        ? PriceSpec.fromPartial(object.twapLimitPrice)
        : undefined
    message.startingPrice =
      object.startingPrice !== undefined && object.startingPrice !== null
        ? PriceSpec.fromPartial(object.startingPrice)
        : undefined
    message.scaleRange =
      object.scaleRange !== undefined && object.scaleRange !== null
        ? PriceBand.fromPartial(object.scaleRange)
        : undefined
    message.scaleOrderCount = object.scaleOrderCount ?? undefined
    message.scaleSizeRatio = object.scaleSizeRatio ?? undefined
    return message
  },
}

function createBaseAmount(): Amount {
  return {
    kind: 0,
    value: undefined,
    currency: undefined,
    matchPositionKey: undefined,
    matchBasis: undefined,
    matchLegIndex: undefined,
  }
}

export const Amount: MessageFns<Amount> = {
  encode(message: Amount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind)
    }
    if (message.value !== undefined) {
      writer.uint32(18).string(message.value)
    }
    if (message.currency !== undefined) {
      writer.uint32(26).string(message.currency)
    }
    if (message.matchPositionKey !== undefined) {
      writer.uint32(34).string(message.matchPositionKey)
    }
    if (message.matchBasis !== undefined) {
      writer.uint32(40).int32(message.matchBasis)
    }
    if (message.matchLegIndex !== undefined) {
      writer.uint32(48).uint32(message.matchLegIndex)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Amount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAmount()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.matchPositionKey = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.matchBasis = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.matchLegIndex = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Amount {
    return {
      kind: isSet(object.kind) ? amountKindFromJSON(object.kind) : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : undefined,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : undefined,
      matchPositionKey: isSet(object.matchPositionKey)
        ? globalThis.String(object.matchPositionKey)
        : isSet(object.match_position_key)
          ? globalThis.String(object.match_position_key)
          : undefined,
      matchBasis: isSet(object.matchBasis)
        ? matchPositionBasisFromJSON(object.matchBasis)
        : isSet(object.match_basis)
          ? matchPositionBasisFromJSON(object.match_basis)
          : undefined,
      matchLegIndex: isSet(object.matchLegIndex)
        ? globalThis.Number(object.matchLegIndex)
        : isSet(object.match_leg_index)
          ? globalThis.Number(object.match_leg_index)
          : undefined,
    }
  },

  toJSON(message: Amount): unknown {
    const obj: any = {}
    if (message.kind !== 0) {
      obj.kind = amountKindToJSON(message.kind)
    }
    if (message.value !== undefined) {
      obj.value = message.value
    }
    if (message.currency !== undefined) {
      obj.currency = message.currency
    }
    if (message.matchPositionKey !== undefined) {
      obj.matchPositionKey = message.matchPositionKey
    }
    if (message.matchBasis !== undefined) {
      obj.matchBasis = matchPositionBasisToJSON(message.matchBasis)
    }
    if (message.matchLegIndex !== undefined) {
      obj.matchLegIndex = Math.round(message.matchLegIndex)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Amount>, I>>(base?: I): Amount {
    return Amount.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Amount>, I>>(object: I): Amount {
    const message = createBaseAmount()
    message.kind = object.kind ?? 0
    message.value = object.value ?? undefined
    message.currency = object.currency ?? undefined
    message.matchPositionKey = object.matchPositionKey ?? undefined
    message.matchBasis = object.matchBasis ?? undefined
    message.matchLegIndex = object.matchLegIndex ?? undefined
    return message
  },
}

function createBaseInstrumentRef(): InstrumentRef {
  return { symbol: undefined, option: undefined }
}

export const InstrumentRef: MessageFns<InstrumentRef> = {
  encode(message: InstrumentRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== undefined) {
      writer.uint32(10).string(message.symbol)
    }
    if (message.option !== undefined) {
      OptionSelector.encode(message.option, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstrumentRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInstrumentRef()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.option = OptionSelector.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InstrumentRef {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      option: isSet(object.option) ? OptionSelector.fromJSON(object.option) : undefined,
    }
  },

  toJSON(message: InstrumentRef): unknown {
    const obj: any = {}
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol
    }
    if (message.option !== undefined) {
      obj.option = OptionSelector.toJSON(message.option)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InstrumentRef>, I>>(base?: I): InstrumentRef {
    return InstrumentRef.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InstrumentRef>, I>>(object: I): InstrumentRef {
    const message = createBaseInstrumentRef()
    message.symbol = object.symbol ?? undefined
    message.option =
      object.option !== undefined && object.option !== null
        ? OptionSelector.fromPartial(object.option)
        : undefined
    return message
  },
}

function createBasePositionRef(): PositionRef {
  return {
    positionId: undefined,
    instrument: undefined,
    asset: undefined,
    dust: undefined,
    allPositions: undefined,
  }
}

export const PositionRef: MessageFns<PositionRef> = {
  encode(message: PositionRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.positionId !== undefined) {
      writer.uint32(10).string(message.positionId)
    }
    if (message.instrument !== undefined) {
      InstrumentRef.encode(message.instrument, writer.uint32(18).fork()).join()
    }
    if (message.asset !== undefined) {
      AssetRef.encode(message.asset, writer.uint32(26).fork()).join()
    }
    if (message.dust !== undefined) {
      DustSelector.encode(message.dust, writer.uint32(34).fork()).join()
    }
    if (message.allPositions !== undefined) {
      AllPositions.encode(message.allPositions, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePositionRef()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.positionId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.instrument = InstrumentRef.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.asset = AssetRef.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.dust = DustSelector.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.allPositions = AllPositions.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PositionRef {
    return {
      positionId: isSet(object.positionId)
        ? globalThis.String(object.positionId)
        : isSet(object.position_id)
          ? globalThis.String(object.position_id)
          : undefined,
      instrument: isSet(object.instrument) ? InstrumentRef.fromJSON(object.instrument) : undefined,
      asset: isSet(object.asset) ? AssetRef.fromJSON(object.asset) : undefined,
      dust: isSet(object.dust) ? DustSelector.fromJSON(object.dust) : undefined,
      allPositions: isSet(object.allPositions)
        ? AllPositions.fromJSON(object.allPositions)
        : isSet(object.all_positions)
          ? AllPositions.fromJSON(object.all_positions)
          : undefined,
    }
  },

  toJSON(message: PositionRef): unknown {
    const obj: any = {}
    if (message.positionId !== undefined) {
      obj.positionId = message.positionId
    }
    if (message.instrument !== undefined) {
      obj.instrument = InstrumentRef.toJSON(message.instrument)
    }
    if (message.asset !== undefined) {
      obj.asset = AssetRef.toJSON(message.asset)
    }
    if (message.dust !== undefined) {
      obj.dust = DustSelector.toJSON(message.dust)
    }
    if (message.allPositions !== undefined) {
      obj.allPositions = AllPositions.toJSON(message.allPositions)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PositionRef>, I>>(base?: I): PositionRef {
    return PositionRef.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PositionRef>, I>>(object: I): PositionRef {
    const message = createBasePositionRef()
    message.positionId = object.positionId ?? undefined
    message.instrument =
      object.instrument !== undefined && object.instrument !== null
        ? InstrumentRef.fromPartial(object.instrument)
        : undefined
    message.asset =
      object.asset !== undefined && object.asset !== null
        ? AssetRef.fromPartial(object.asset)
        : undefined
    message.dust =
      object.dust !== undefined && object.dust !== null
        ? DustSelector.fromPartial(object.dust)
        : undefined
    message.allPositions =
      object.allPositions !== undefined && object.allPositions !== null
        ? AllPositions.fromPartial(object.allPositions)
        : undefined
    return message
  },
}

function createBaseDustSelector(): DustSelector {
  return {}
}

export const DustSelector: MessageFns<DustSelector> = {
  encode(_: DustSelector, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DustSelector {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDustSelector()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): DustSelector {
    return {}
  },

  toJSON(_: DustSelector): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<DustSelector>, I>>(base?: I): DustSelector {
    return DustSelector.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DustSelector>, I>>(_: I): DustSelector {
    const message = createBaseDustSelector()
    return message
  },
}

function createBaseAllPositions(): AllPositions {
  return {}
}

export const AllPositions: MessageFns<AllPositions> = {
  encode(_: AllPositions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AllPositions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAllPositions()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): AllPositions {
    return {}
  },

  toJSON(_: AllPositions): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<AllPositions>, I>>(base?: I): AllPositions {
    return AllPositions.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AllPositions>, I>>(_: I): AllPositions {
    const message = createBaseAllPositions()
    return message
  },
}

function createBasePriceSpec(): PriceSpec {
  return { absolute: undefined, relative: undefined, band: undefined }
}

export const PriceSpec: MessageFns<PriceSpec> = {
  encode(message: PriceSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.absolute !== undefined) {
      writer.uint32(10).string(message.absolute)
    }
    if (message.relative !== undefined) {
      RelativePrice.encode(message.relative, writer.uint32(18).fork()).join()
    }
    if (message.band !== undefined) {
      PriceBand.encode(message.band, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PriceSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePriceSpec()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.absolute = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.relative = RelativePrice.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.band = PriceBand.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PriceSpec {
    return {
      absolute: isSet(object.absolute) ? globalThis.String(object.absolute) : undefined,
      relative: isSet(object.relative) ? RelativePrice.fromJSON(object.relative) : undefined,
      band: isSet(object.band) ? PriceBand.fromJSON(object.band) : undefined,
    }
  },

  toJSON(message: PriceSpec): unknown {
    const obj: any = {}
    if (message.absolute !== undefined) {
      obj.absolute = message.absolute
    }
    if (message.relative !== undefined) {
      obj.relative = RelativePrice.toJSON(message.relative)
    }
    if (message.band !== undefined) {
      obj.band = PriceBand.toJSON(message.band)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PriceSpec>, I>>(base?: I): PriceSpec {
    return PriceSpec.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PriceSpec>, I>>(object: I): PriceSpec {
    const message = createBasePriceSpec()
    message.absolute = object.absolute ?? undefined
    message.relative =
      object.relative !== undefined && object.relative !== null
        ? RelativePrice.fromPartial(object.relative)
        : undefined
    message.band =
      object.band !== undefined && object.band !== null
        ? PriceBand.fromPartial(object.band)
        : undefined
    return message
  },
}

function createBasePriceBand(): PriceBand {
  return { minPrice: undefined, maxPrice: undefined }
}

export const PriceBand: MessageFns<PriceBand> = {
  encode(message: PriceBand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minPrice !== undefined) {
      PriceBound.encode(message.minPrice, writer.uint32(10).fork()).join()
    }
    if (message.maxPrice !== undefined) {
      PriceBound.encode(message.maxPrice, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PriceBand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePriceBand()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.minPrice = PriceBound.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.maxPrice = PriceBound.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PriceBand {
    return {
      minPrice: isSet(object.minPrice)
        ? PriceBound.fromJSON(object.minPrice)
        : isSet(object.min_price)
          ? PriceBound.fromJSON(object.min_price)
          : undefined,
      maxPrice: isSet(object.maxPrice)
        ? PriceBound.fromJSON(object.maxPrice)
        : isSet(object.max_price)
          ? PriceBound.fromJSON(object.max_price)
          : undefined,
    }
  },

  toJSON(message: PriceBand): unknown {
    const obj: any = {}
    if (message.minPrice !== undefined) {
      obj.minPrice = PriceBound.toJSON(message.minPrice)
    }
    if (message.maxPrice !== undefined) {
      obj.maxPrice = PriceBound.toJSON(message.maxPrice)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PriceBand>, I>>(base?: I): PriceBand {
    return PriceBand.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PriceBand>, I>>(object: I): PriceBand {
    const message = createBasePriceBand()
    message.minPrice =
      object.minPrice !== undefined && object.minPrice !== null
        ? PriceBound.fromPartial(object.minPrice)
        : undefined
    message.maxPrice =
      object.maxPrice !== undefined && object.maxPrice !== null
        ? PriceBound.fromPartial(object.maxPrice)
        : undefined
    return message
  },
}

function createBasePriceBound(): PriceBound {
  return { absolute: undefined, relative: undefined }
}

export const PriceBound: MessageFns<PriceBound> = {
  encode(message: PriceBound, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.absolute !== undefined) {
      writer.uint32(10).string(message.absolute)
    }
    if (message.relative !== undefined) {
      RelativePrice.encode(message.relative, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PriceBound {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePriceBound()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.absolute = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.relative = RelativePrice.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PriceBound {
    return {
      absolute: isSet(object.absolute) ? globalThis.String(object.absolute) : undefined,
      relative: isSet(object.relative) ? RelativePrice.fromJSON(object.relative) : undefined,
    }
  },

  toJSON(message: PriceBound): unknown {
    const obj: any = {}
    if (message.absolute !== undefined) {
      obj.absolute = message.absolute
    }
    if (message.relative !== undefined) {
      obj.relative = RelativePrice.toJSON(message.relative)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PriceBound>, I>>(base?: I): PriceBound {
    return PriceBound.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PriceBound>, I>>(object: I): PriceBound {
    const message = createBasePriceBound()
    message.absolute = object.absolute ?? undefined
    message.relative =
      object.relative !== undefined && object.relative !== null
        ? RelativePrice.fromPartial(object.relative)
        : undefined
    return message
  },
}

function createBaseRelativePrice(): RelativePrice {
  return { anchor: 0, offset: '', offsetUnit: 0 }
}

export const RelativePrice: MessageFns<RelativePrice> = {
  encode(message: RelativePrice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.anchor !== 0) {
      writer.uint32(8).int32(message.anchor)
    }
    if (message.offset !== '') {
      writer.uint32(18).string(message.offset)
    }
    if (message.offsetUnit !== 0) {
      writer.uint32(24).int32(message.offsetUnit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RelativePrice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRelativePrice()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.anchor = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.offset = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.offsetUnit = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RelativePrice {
    return {
      anchor: isSet(object.anchor) ? priceReferenceFromJSON(object.anchor) : 0,
      offset: isSet(object.offset) ? globalThis.String(object.offset) : '',
      offsetUnit: isSet(object.offsetUnit)
        ? priceOffsetUnitFromJSON(object.offsetUnit)
        : isSet(object.offset_unit)
          ? priceOffsetUnitFromJSON(object.offset_unit)
          : 0,
    }
  },

  toJSON(message: RelativePrice): unknown {
    const obj: any = {}
    if (message.anchor !== 0) {
      obj.anchor = priceReferenceToJSON(message.anchor)
    }
    if (message.offset !== '') {
      obj.offset = message.offset
    }
    if (message.offsetUnit !== 0) {
      obj.offsetUnit = priceOffsetUnitToJSON(message.offsetUnit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RelativePrice>, I>>(base?: I): RelativePrice {
    return RelativePrice.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RelativePrice>, I>>(object: I): RelativePrice {
    const message = createBaseRelativePrice()
    message.anchor = object.anchor ?? 0
    message.offset = object.offset ?? ''
    message.offsetUnit = object.offsetUnit ?? 0
    return message
  },
}

function createBaseOptionSelector(): OptionSelector {
  return {
    underlying: undefined,
    optionType: 0,
    expiry: undefined,
    strike: undefined,
    settlementCurrency: '',
  }
}

export const OptionSelector: MessageFns<OptionSelector> = {
  encode(message: OptionSelector, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.underlying !== undefined) {
      AssetRef.encode(message.underlying, writer.uint32(10).fork()).join()
    }
    if (message.optionType !== 0) {
      writer.uint32(16).int32(message.optionType)
    }
    if (message.expiry !== undefined) {
      ExpirySpec.encode(message.expiry, writer.uint32(26).fork()).join()
    }
    if (message.strike !== undefined) {
      StrikeSpec.encode(message.strike, writer.uint32(34).fork()).join()
    }
    if (message.settlementCurrency !== '') {
      writer.uint32(42).string(message.settlementCurrency)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionSelector {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOptionSelector()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.underlying = AssetRef.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.optionType = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.expiry = ExpirySpec.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.strike = StrikeSpec.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.settlementCurrency = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OptionSelector {
    return {
      underlying: isSet(object.underlying) ? AssetRef.fromJSON(object.underlying) : undefined,
      optionType: isSet(object.optionType)
        ? optionTypeFromJSON(object.optionType)
        : isSet(object.option_type)
          ? optionTypeFromJSON(object.option_type)
          : 0,
      expiry: isSet(object.expiry) ? ExpirySpec.fromJSON(object.expiry) : undefined,
      strike: isSet(object.strike) ? StrikeSpec.fromJSON(object.strike) : undefined,
      settlementCurrency: isSet(object.settlementCurrency)
        ? globalThis.String(object.settlementCurrency)
        : isSet(object.settlement_currency)
          ? globalThis.String(object.settlement_currency)
          : '',
    }
  },

  toJSON(message: OptionSelector): unknown {
    const obj: any = {}
    if (message.underlying !== undefined) {
      obj.underlying = AssetRef.toJSON(message.underlying)
    }
    if (message.optionType !== 0) {
      obj.optionType = optionTypeToJSON(message.optionType)
    }
    if (message.expiry !== undefined) {
      obj.expiry = ExpirySpec.toJSON(message.expiry)
    }
    if (message.strike !== undefined) {
      obj.strike = StrikeSpec.toJSON(message.strike)
    }
    if (message.settlementCurrency !== '') {
      obj.settlementCurrency = message.settlementCurrency
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OptionSelector>, I>>(base?: I): OptionSelector {
    return OptionSelector.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OptionSelector>, I>>(object: I): OptionSelector {
    const message = createBaseOptionSelector()
    message.underlying =
      object.underlying !== undefined && object.underlying !== null
        ? AssetRef.fromPartial(object.underlying)
        : undefined
    message.optionType = object.optionType ?? 0
    message.expiry =
      object.expiry !== undefined && object.expiry !== null
        ? ExpirySpec.fromPartial(object.expiry)
        : undefined
    message.strike =
      object.strike !== undefined && object.strike !== null
        ? StrikeSpec.fromPartial(object.strike)
        : undefined
    message.settlementCurrency = object.settlementCurrency ?? ''
    return message
  },
}

function createBaseStrikeSpec(): StrikeSpec {
  return { absolute: undefined, delta: undefined, moneynessPercent: undefined }
}

export const StrikeSpec: MessageFns<StrikeSpec> = {
  encode(message: StrikeSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.absolute !== undefined) {
      writer.uint32(10).string(message.absolute)
    }
    if (message.delta !== undefined) {
      writer.uint32(18).string(message.delta)
    }
    if (message.moneynessPercent !== undefined) {
      writer.uint32(26).string(message.moneynessPercent)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StrikeSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseStrikeSpec()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.absolute = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.delta = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.moneynessPercent = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): StrikeSpec {
    return {
      absolute: isSet(object.absolute) ? globalThis.String(object.absolute) : undefined,
      delta: isSet(object.delta) ? globalThis.String(object.delta) : undefined,
      moneynessPercent: isSet(object.moneynessPercent)
        ? globalThis.String(object.moneynessPercent)
        : isSet(object.moneyness_percent)
          ? globalThis.String(object.moneyness_percent)
          : undefined,
    }
  },

  toJSON(message: StrikeSpec): unknown {
    const obj: any = {}
    if (message.absolute !== undefined) {
      obj.absolute = message.absolute
    }
    if (message.delta !== undefined) {
      obj.delta = message.delta
    }
    if (message.moneynessPercent !== undefined) {
      obj.moneynessPercent = message.moneynessPercent
    }
    return obj
  },

  create<I extends Exact<DeepPartial<StrikeSpec>, I>>(base?: I): StrikeSpec {
    return StrikeSpec.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<StrikeSpec>, I>>(object: I): StrikeSpec {
    const message = createBaseStrikeSpec()
    message.absolute = object.absolute ?? undefined
    message.delta = object.delta ?? undefined
    message.moneynessPercent = object.moneynessPercent ?? undefined
    return message
  },
}

function createBaseExpirySpec(): ExpirySpec {
  return { unixMs: undefined, date: undefined, tenor: undefined, nearest: undefined }
}

export const ExpirySpec: MessageFns<ExpirySpec> = {
  encode(message: ExpirySpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.unixMs !== undefined) {
      writer.uint32(8).int64(message.unixMs)
    }
    if (message.date !== undefined) {
      writer.uint32(18).string(message.date)
    }
    if (message.tenor !== undefined) {
      TenorSpec.encode(message.tenor, writer.uint32(26).fork()).join()
    }
    if (message.nearest !== undefined) {
      NearestExpiry.encode(message.nearest, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExpirySpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExpirySpec()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.unixMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.date = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.tenor = TenorSpec.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.nearest = NearestExpiry.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExpirySpec {
    return {
      unixMs: isSet(object.unixMs)
        ? globalThis.String(object.unixMs)
        : isSet(object.unix_ms)
          ? globalThis.String(object.unix_ms)
          : undefined,
      date: isSet(object.date) ? globalThis.String(object.date) : undefined,
      tenor: isSet(object.tenor) ? TenorSpec.fromJSON(object.tenor) : undefined,
      nearest: isSet(object.nearest) ? NearestExpiry.fromJSON(object.nearest) : undefined,
    }
  },

  toJSON(message: ExpirySpec): unknown {
    const obj: any = {}
    if (message.unixMs !== undefined) {
      obj.unixMs = message.unixMs
    }
    if (message.date !== undefined) {
      obj.date = message.date
    }
    if (message.tenor !== undefined) {
      obj.tenor = TenorSpec.toJSON(message.tenor)
    }
    if (message.nearest !== undefined) {
      obj.nearest = NearestExpiry.toJSON(message.nearest)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExpirySpec>, I>>(base?: I): ExpirySpec {
    return ExpirySpec.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExpirySpec>, I>>(object: I): ExpirySpec {
    const message = createBaseExpirySpec()
    message.unixMs = object.unixMs ?? undefined
    message.date = object.date ?? undefined
    message.tenor =
      object.tenor !== undefined && object.tenor !== null
        ? TenorSpec.fromPartial(object.tenor)
        : undefined
    message.nearest =
      object.nearest !== undefined && object.nearest !== null
        ? NearestExpiry.fromPartial(object.nearest)
        : undefined
    return message
  },
}

function createBaseTenorSpec(): TenorSpec {
  return { value: 0, unit: 0 }
}

export const TenorSpec: MessageFns<TenorSpec> = {
  encode(message: TenorSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== 0) {
      writer.uint32(8).uint32(message.value)
    }
    if (message.unit !== 0) {
      writer.uint32(16).int32(message.unit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TenorSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTenorSpec()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.value = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.unit = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TenorSpec {
    return {
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
      unit: isSet(object.unit) ? tenorUnitFromJSON(object.unit) : 0,
    }
  },

  toJSON(message: TenorSpec): unknown {
    const obj: any = {}
    if (message.value !== 0) {
      obj.value = Math.round(message.value)
    }
    if (message.unit !== 0) {
      obj.unit = tenorUnitToJSON(message.unit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TenorSpec>, I>>(base?: I): TenorSpec {
    return TenorSpec.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TenorSpec>, I>>(object: I): TenorSpec {
    const message = createBaseTenorSpec()
    message.value = object.value ?? 0
    message.unit = object.unit ?? 0
    return message
  },
}

function createBaseNearestExpiry(): NearestExpiry {
  return { minDays: undefined, maxDays: undefined }
}

export const NearestExpiry: MessageFns<NearestExpiry> = {
  encode(message: NearestExpiry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minDays !== undefined) {
      writer.uint32(8).int64(message.minDays)
    }
    if (message.maxDays !== undefined) {
      writer.uint32(16).int64(message.maxDays)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NearestExpiry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseNearestExpiry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.minDays = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.maxDays = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): NearestExpiry {
    return {
      minDays: isSet(object.minDays)
        ? globalThis.String(object.minDays)
        : isSet(object.min_days)
          ? globalThis.String(object.min_days)
          : undefined,
      maxDays: isSet(object.maxDays)
        ? globalThis.String(object.maxDays)
        : isSet(object.max_days)
          ? globalThis.String(object.max_days)
          : undefined,
    }
  },

  toJSON(message: NearestExpiry): unknown {
    const obj: any = {}
    if (message.minDays !== undefined) {
      obj.minDays = message.minDays
    }
    if (message.maxDays !== undefined) {
      obj.maxDays = message.maxDays
    }
    return obj
  },

  create<I extends Exact<DeepPartial<NearestExpiry>, I>>(base?: I): NearestExpiry {
    return NearestExpiry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<NearestExpiry>, I>>(object: I): NearestExpiry {
    const message = createBaseNearestExpiry()
    message.minDays = object.minDays ?? undefined
    message.maxDays = object.maxDays ?? undefined
    return message
  },
}

function createBaseTestIntentCompilerRequest(): TestIntentCompilerRequest {
  return { intent: undefined, snapshot: undefined, storageExchange: undefined }
}

export const TestIntentCompilerRequest: MessageFns<TestIntentCompilerRequest> = {
  encode(
    message: TestIntentCompilerRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.intent !== undefined) {
      TradeIntent.encode(message.intent, writer.uint32(10).fork()).join()
    }
    if (message.snapshot !== undefined) {
      TestAccountSnapshot.encode(message.snapshot, writer.uint32(18).fork()).join()
    }
    if (message.storageExchange !== undefined) {
      writer.uint32(26).string(message.storageExchange)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestIntentCompilerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTestIntentCompilerRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.intent = TradeIntent.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.snapshot = TestAccountSnapshot.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.storageExchange = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TestIntentCompilerRequest {
    return {
      intent: isSet(object.intent) ? TradeIntent.fromJSON(object.intent) : undefined,
      snapshot: isSet(object.snapshot) ? TestAccountSnapshot.fromJSON(object.snapshot) : undefined,
      storageExchange: isSet(object.storageExchange)
        ? globalThis.String(object.storageExchange)
        : isSet(object.storage_exchange)
          ? globalThis.String(object.storage_exchange)
          : undefined,
    }
  },

  toJSON(message: TestIntentCompilerRequest): unknown {
    const obj: any = {}
    if (message.intent !== undefined) {
      obj.intent = TradeIntent.toJSON(message.intent)
    }
    if (message.snapshot !== undefined) {
      obj.snapshot = TestAccountSnapshot.toJSON(message.snapshot)
    }
    if (message.storageExchange !== undefined) {
      obj.storageExchange = message.storageExchange
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TestIntentCompilerRequest>, I>>(
    base?: I
  ): TestIntentCompilerRequest {
    return TestIntentCompilerRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TestIntentCompilerRequest>, I>>(
    object: I
  ): TestIntentCompilerRequest {
    const message = createBaseTestIntentCompilerRequest()
    message.intent =
      object.intent !== undefined && object.intent !== null
        ? TradeIntent.fromPartial(object.intent)
        : undefined
    message.snapshot =
      object.snapshot !== undefined && object.snapshot !== null
        ? TestAccountSnapshot.fromPartial(object.snapshot)
        : undefined
    message.storageExchange = object.storageExchange ?? undefined
    return message
  },
}

function createBaseTestAccountSnapshot(): TestAccountSnapshot {
  return {
    balances: [],
    positions: [],
    openOrders: [],
    algoStates: [],
    instruments: [],
    tickers: [],
  }
}

export const TestAccountSnapshot: MessageFns<TestAccountSnapshot> = {
  encode(message: TestAccountSnapshot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.balances) {
      PortfolioData.encode(v!, writer.uint32(10).fork()).join()
    }
    for (const v of message.positions) {
      TestPosition.encode(v!, writer.uint32(18).fork()).join()
    }
    for (const v of message.openOrders) {
      Order.encode(v!, writer.uint32(26).fork()).join()
    }
    for (const v of message.algoStates) {
      AlgoState.encode(v!, writer.uint32(34).fork()).join()
    }
    for (const v of message.instruments) {
      Instrument.encode(v!, writer.uint32(42).fork()).join()
    }
    for (const v of message.tickers) {
      TestTicker.encode(v!, writer.uint32(50).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestAccountSnapshot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTestAccountSnapshot()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.balances.push(PortfolioData.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.positions.push(TestPosition.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.openOrders.push(Order.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.algoStates.push(AlgoState.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.instruments.push(Instrument.decode(reader, reader.uint32()))
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.tickers.push(TestTicker.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TestAccountSnapshot {
    return {
      balances: globalThis.Array.isArray(object?.balances)
        ? object.balances.map((e: any) => PortfolioData.fromJSON(e))
        : [],
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => TestPosition.fromJSON(e))
        : [],
      openOrders: globalThis.Array.isArray(object?.openOrders)
        ? object.openOrders.map((e: any) => Order.fromJSON(e))
        : globalThis.Array.isArray(object?.open_orders)
          ? object.open_orders.map((e: any) => Order.fromJSON(e))
          : [],
      algoStates: globalThis.Array.isArray(object?.algoStates)
        ? object.algoStates.map((e: any) => AlgoState.fromJSON(e))
        : globalThis.Array.isArray(object?.algo_states)
          ? object.algo_states.map((e: any) => AlgoState.fromJSON(e))
          : [],
      instruments: globalThis.Array.isArray(object?.instruments)
        ? object.instruments.map((e: any) => Instrument.fromJSON(e))
        : [],
      tickers: globalThis.Array.isArray(object?.tickers)
        ? object.tickers.map((e: any) => TestTicker.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TestAccountSnapshot): unknown {
    const obj: any = {}
    if (message.balances?.length) {
      obj.balances = message.balances.map((e) => PortfolioData.toJSON(e))
    }
    if (message.positions?.length) {
      obj.positions = message.positions.map((e) => TestPosition.toJSON(e))
    }
    if (message.openOrders?.length) {
      obj.openOrders = message.openOrders.map((e) => Order.toJSON(e))
    }
    if (message.algoStates?.length) {
      obj.algoStates = message.algoStates.map((e) => AlgoState.toJSON(e))
    }
    if (message.instruments?.length) {
      obj.instruments = message.instruments.map((e) => Instrument.toJSON(e))
    }
    if (message.tickers?.length) {
      obj.tickers = message.tickers.map((e) => TestTicker.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TestAccountSnapshot>, I>>(base?: I): TestAccountSnapshot {
    return TestAccountSnapshot.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TestAccountSnapshot>, I>>(
    object: I
  ): TestAccountSnapshot {
    const message = createBaseTestAccountSnapshot()
    message.balances = object.balances?.map((e) => PortfolioData.fromPartial(e)) || []
    message.positions = object.positions?.map((e) => TestPosition.fromPartial(e)) || []
    message.openOrders = object.openOrders?.map((e) => Order.fromPartial(e)) || []
    message.algoStates = object.algoStates?.map((e) => AlgoState.fromPartial(e)) || []
    message.instruments = object.instruments?.map((e) => Instrument.fromPartial(e)) || []
    message.tickers = object.tickers?.map((e) => TestTicker.fromPartial(e)) || []
    return message
  },
}

function createBaseTestTicker(): TestTicker {
  return { symbol: '', markPrice: '' }
}

export const TestTicker: MessageFns<TestTicker> = {
  encode(message: TestTicker, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.markPrice !== '') {
      writer.uint32(18).string(message.markPrice)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestTicker {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTestTicker()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.markPrice = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TestTicker {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      markPrice: isSet(object.markPrice)
        ? globalThis.String(object.markPrice)
        : isSet(object.mark_price)
          ? globalThis.String(object.mark_price)
          : '',
    }
  },

  toJSON(message: TestTicker): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.markPrice !== '') {
      obj.markPrice = message.markPrice
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TestTicker>, I>>(base?: I): TestTicker {
    return TestTicker.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TestTicker>, I>>(object: I): TestTicker {
    const message = createBaseTestTicker()
    message.symbol = object.symbol ?? ''
    message.markPrice = object.markPrice ?? ''
    return message
  },
}

function createBaseTestPosition(): TestPosition {
  return { symbol: '', quantity: '', side: 0, sizeDenomination: 0 }
}

export const TestPosition: MessageFns<TestPosition> = {
  encode(message: TestPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.quantity !== '') {
      writer.uint32(18).string(message.quantity)
    }
    if (message.side !== 0) {
      writer.uint32(24).int32(message.side)
    }
    if (message.sizeDenomination !== 0) {
      writer.uint32(32).int32(message.sizeDenomination)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTestPosition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.sizeDenomination = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TestPosition {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      sizeDenomination: isSet(object.sizeDenomination)
        ? denominationFromJSON(object.sizeDenomination)
        : isSet(object.size_denomination)
          ? denominationFromJSON(object.size_denomination)
          : 0,
    }
  },

  toJSON(message: TestPosition): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.sizeDenomination !== 0) {
      obj.sizeDenomination = denominationToJSON(message.sizeDenomination)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TestPosition>, I>>(base?: I): TestPosition {
    return TestPosition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TestPosition>, I>>(object: I): TestPosition {
    const message = createBaseTestPosition()
    message.symbol = object.symbol ?? ''
    message.quantity = object.quantity ?? ''
    message.side = object.side ?? 0
    message.sizeDenomination = object.sizeDenomination ?? 0
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
